import React, { useState, useEffect, useRef, useMemo } from 'react'
import { Form, InputNumber, /*Popconfirm,*/ Typography, Radio, Select, Col, Row, Input, Checkbox, Table, Space, Tooltip, Progress, Switch } from "antd";
// import pptIcon from '../../assets/images/icons/ppt.svg';
import GreenCheckBg from '../../assets/images/icons/green_check_round_bg.svg';
import DownloadOrangeIcon from '../../assets/images/icons/download_csv_icon.svg';
import Edit from '../../assets/images/icons/edit.svg';
// import FullLoader from "../../assets/images/full-page-loader.gif"
import uploadIcon from '../../assets/images/icons/upload-cloud.svg';
import FileIcon from '../../assets/images/icons/offcanva_file_icon.svg';
import deleteIcon from '../../assets/images/icons/trash.svg';
import axios from "axios";
import configData from "../../config/config.json";
import Offcanvas from 'react-bootstrap/Offcanvas';
import constantData from "../../constants/constantData.json";
import Cookies from "js-cookie";
import InventoryProcessingLoader from "../../assets/images/inventory_processing_loader.gif"
// import { jwtDecode } from "jwt-decode";
import { notifyfailure } from "../../utils/toast";
import { notifycatch } from "../../utils/toast";
import loaderIcon from '../../assets/images/icons/loader.gif';
import { notifysuccess } from "../../utils/toast";
import * as XLSX from "xlsx";
import { Upload/*, message*/ } from "antd";
import { Link } from "react-router-dom";
import backButton from '../../assets/images/back_button_arrow.svg';
import publishersIcon from '../../assets/images/icons/publishers.svg';
import { saveAs } from "file-saver";

// inventoryRules.js
export const inventoryTemplates = {
    "Website": {
        // key: { headerName, required, type: "text"|"number"|"url"|"select", options?, mandatory? }
        inventory_provider: { header: "Inventory Provider (Select “Owned & Operated” if you own the property)", required: true, type: "select", options: ["O&O", "Resold"] },
        domain: { header: "Domain", required: true, type: "url", editable: false },
        traffic_type: { header: "Traffic Type (Banner/Video/Native)", required: true, type: "select", options: ["Banner", "Video", "Native"] },
        geo: {
            header: "Geo",
            required: true,
            type: "select",
        },
        avg_ecpm: { header: "Average eCPM ($)", required: false, type: "number" },
        last_30_avails: { header: "Last 30 days Avails", required: true, type: "number" }
    },
    "Mobile App (Android / iOS)": {
        inventory_provider: { header: "Inventory Provider (Select “Owned & Operated” if you own the property)", required: true, type: "select", options: ["O&O", "Resold"] },
        app_bundle: { header: "App bundle", required: true, type: "text", editable: false },
        app_store_url: { header: "App Store URL", required: false, type: "url", editable: false },
        app_name: { header: "App Name", required: false, type: "text" },
        app_ads_txt_url: { header: "App-ads.txt URL", required: true, type: "url" },
        traffic_type: { header: "Traffic Type (Banner/Video/Native)", required: true, type: "select", options: ["Banner", "Video", "Native"] },
        geo: {
            header: "Geo",
            required: true,
            type: "select",
        },
        avg_ecpm: { header: "Average eCPM ($)", required: false, type: "number" },
        last_30_avails: { header: "Last 30 days Avails", required: true, type: "number" }
    },
    "CTV / FAST Apps": {
        inventory_provider: { header: "Inventory Provider (Select “Owned & Operated” if you own the property)", required: true, type: "select", options: ["O&O", "Resold"] },
        store: {
            header: "Store (Android/IOS/LG/etc)", required: true, type: "select", options: [
                "Samsung Smart Hub",
                "Google Play (Android TV)",
                "LG Content Store",
                "Amazon Appstore",
                "Roku Channel Store",
                "Vizio App Store",
                "Apple App Store (tvOS)",
                "Xiaomi GetApps (PatchWall)",
                "Jio Store",
                "VIDAA (Hisense)",
                "WhaleStore (Zeasn)",
                "Titan OS",
                "TiVo OS",
                "Sky Q / Sky Glass",
                "Foxxum App Store",
                "NetRange",
                "Xbox Store",
                "PlayStation Store",
                "Xfinity X1 / Flex",
                "Panasonic App Store",
                "Huawei AppGallery",
                "Metrological Store",
                "Aptoide TV",
                "Vewd (now Xperi)",
                "Vestel Smart Center",
                "Samba TV",
                "Fetch TV Store",
                "Freebox OS Store",
                "Magenta TV Store",
                "UPC / Liberty Global"
            ]
        },
        app_bundle: { header: "App bundle", required: true, type: "text", editable: false },
        app_name: { header: "App Name", required: true, type: "text" },
        app_store_url: { header: "App Store URL", required: true, type: "url", editable: false },
        app_ads_txt_url: { header: "App-ads.txt URL", required: true, type: "url" },
        inventory_partner_domain: { header: "Inventory Partner Domain URL", required: false, type: "url" },
        geo: {
            header: "Geo",
            required: true,
            type: "select",
        },
        avg_ecpm: { header: "Average eCPM ($)", required: false, type: "number" },
        last_30_avails: { header: "Last 30 days Avails", required: true, type: "number" }
    }
};

const parseExcelFile = async (file) => {
    const arrayBuffer = await file.arrayBuffer();
    const workbook = XLSX.read(arrayBuffer, { type: "array" });
    // assume first sheet is the data sheet:
    const firstSheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[firstSheetName];
    // Convert to JSON with raw values replaced by blank if undefined
    const json = XLSX.utils.sheet_to_json(worksheet, { defval: "" });
    return json; // array of objects where keys are header titles
};

const EditableCell = ({
    editing,
    dataIndex,
    title,
    inputType,
    options,
    record,
    required,
    children,
    ...restProps
}) => {
    let inputNode = null;

    // if (inputType === "select") {
    //     inputNode = (
    //         <Select
    //             getPopupContainer={(triggerNode) => triggerNode?.parentNode || document.body}
    //             dropdownMatchSelectWidth={false}
    //             dropdownStyle={{ position: "fixed" }}
    //             optionLabelProp="children"
    //             placement="bottom"
    //             style={{ width: "100%" }}
    //         >
    //             {(options || []).map((opt) => {
    //                 // support opt as string or { value, label }
    //                 const val = typeof opt === "object" ? opt.value : opt;
    //                 const label = typeof opt === "object" ? opt.label : opt;
    //                 // always use string values for stability
    //                 return (
    //                     <Select.Option key={String(val)} value={String(val)}>
    //                         {label}
    //                     </Select.Option>
    //                 );
    //             })}
    //         </Select>
    //     );
    // } 


    if (inputType === "select") {

        if (dataIndex === "geo") {
            inputNode = (

                <Select
                    showSearch
                    placeholder="Select country"
                    options={options}
                    optionFilterProp="label"
                    // getPopupContainer={(triggerNode) => triggerNode?.parentNode || document.body}
                    // dropdownStyle={{
                    //     position: "fixed"
                    //     // , top: "20%"
                    // }}
                    // optionLabelProp="children"
                    // placement="bottom"
                    // style={{ width: "100%" }}
                    popupClassName='custom_ant_select_clsname'
                    getPopupContainer={() => document.body}   // ✅ stable
                    dropdownMatchSelectWidth={true}           // ✅ align width
                    placement="bottomLeft"                    // ✅ always below
                    style={{ width: "100%", zIndex: "1212121212" }}

                />

            );
        }
        else {
            inputNode = (
                <Select
                    getPopupContainer={(triggerNode) => triggerNode?.parentNode || document.body}
                    dropdownMatchSelectWidth={false}
                    dropdownStyle={{ position: "fixed" }}
                    optionLabelProp="children"
                    placement="bottom"
                    style={{ width: "100%" }}
                >
                    {(options || []).map((opt) => {
                        // support opt as string or { value, label }
                        const val = typeof opt === "object" ? opt.value : opt;
                        const label = typeof opt === "object" ? opt.label : opt;
                        // always use string values for stability
                        return (
                            <Select.Option key={String(val)} value={String(val)}>
                                {label}
                            </Select.Option>
                        );
                    })}
                </Select>
            );
        }


    }



    else if (inputType === "number") {
        inputNode = <InputNumber />;
    } else {
        inputNode = <Input />;
    }

    return (
        <td {...restProps}>
            {editing ? (
                <Form.Item
                    name={dataIndex}
                    style={{ margin: 0 }}
                    // rules={[{ required: true, message: `Please Enter ${title}!` }]}
                    rules={required ? [{ required: true, message: `Please enter ${title}!` }] : []}
                >
                    {inputNode}
                </Form.Item>
            ) : (
                children
            )
            }
        </td >
    );
};


const ACTIVATION_OPTIONS = [
    "Activation is possible using a separate tag",
    "Activation is possible at a higher floor price",
    "Otherwise, reach out to me for clarification",
];

const SENSITIVE_BLOCK_IDS = [
    "IAB25-1", "IAB25-2", "IAB25-3", "IAB25-4", "IAB25-5", "IAB25-6", "IAB25-7",
    "IAB26-1", "IAB26-2", "IAB26-3", "IAB26-4",
    "IAB9-9", "IAB8-18", "IAB8-5", "IAB11-4",
];

function CategoryRows({
    node,
    selected,
    setSelected,
    searchTerm = "",
    defaultOpen = false,
    isDisabled,
    sensitive = {},
    setSensitive,
    attemptedIds = new Set(),
    setSensitiveAttemptedIds,
}) {
    const [open, setOpen] = useState(false);

    const hasChildren = node.children && node.children.length > 0;
    const childIds = node.children?.map(c => c.id) || [];

    // Parent is fully ON only when every child is selected
    const allChildrenSelected = hasChildren && childIds.every(id => selected.has(id));
    // Partial: some but not all children selected
    const someChildrenSelected = hasChildren && childIds.some(id => selected.has(id)) && !allChildrenSelected;
    // Switch checked state
    const parentChecked = hasChildren ? allChildrenSelected : selected.has(node.id);
    // Sensitive checkbox visible whenever parent toggle is on (full or partial) or leaf node is selected
    const parentActive = hasChildren ? (allChildrenSelected || someChildrenSelected) : selected.has(node.id);

    // filter visibility (must be before the useEffect that uses childMatches)
    const parentMatches = node.name.toLowerCase().includes(searchTerm);
    const childMatches = (node.children || []).filter(c =>
        c.name.toLowerCase().includes(searchTerm)
    );

    // Close dropdown when parent is toggled off
    useEffect(() => {
        if (!hasChildren) return;
        if (!parentActive) setOpen(false);
    }, [parentActive, hasChildren]);

    // Auto open when search matches children
    useEffect(() => {
        if (!hasChildren) return;
        if (searchTerm) setOpen(childMatches.length > 0);
    }, [searchTerm, hasChildren, childMatches.length]);

    // Toggle parent: any-selected → all OFF, none-selected → all ON
    const toggleParent = () => {
        setSelected(prev => {
            const next = new Set(prev);
            if (hasChildren) {
                if (someChildrenSelected || allChildrenSelected) {
                    childIds.forEach(id => next.delete(id));
                } else {
                    childIds.forEach(id => next.add(id));
                }
            } else {
                if (next.has(node.id)) next.delete(node.id);
                else next.add(node.id);
            }
            return next;
        });
    };

    // Toggle individual child
    const toggleChild = (childId) => {
        setSelected(prev => {
            const next = new Set(prev);
            if (next.has(childId)) next.delete(childId);
            else next.add(childId);
            return next;
        });
    };

    // Sensitive checkbox + select handlers (parent-level only)
    const handleSensitiveCheck = (id) => {
        setSensitive(prev => {
            const current = prev[id] || { isChecked: false, selection: "" };
            return {
                ...prev,
                [id]: { isChecked: !current.isChecked, selection: !current.isChecked ? current.selection : "" },
            };
        });
    };

    const handleSensitiveSelect = (id, value) => {
        setSensitive(prev => ({
            ...prev,
            [id]: { ...(prev[id] || { isChecked: true }), selection: value },
        }));
    };

    if (searchTerm && !parentMatches && childMatches.length === 0) return null;

    return (
        <>
            {/* Parent row */}
            <tr className={`${parentActive ? "bottom_padding_cls" : ""} ${someChildrenSelected ? "is-partial" : ""}`}>
                {/* COL 1: parent switch */}
                <td className="cell checkbox-col">
                    <Switch
                        className={someChildrenSelected ? "switch-partial" : ""}
                        disabled={isDisabled}
                        checked={parentChecked}
                        onChange={() => {
                            // Turning off (any selected → all off): clean sensitive
                            if (someChildrenSelected || allChildrenSelected || selected.has(node.id)) {
                                setSensitive(prev => {
                                    const next = { ...prev };
                                    delete next[node.id];
                                    childIds.forEach(id => delete next[id]);
                                    return next;
                                });
                                setSensitiveAttemptedIds(prev => {
                                    const next = new Set(prev);
                                    next.delete(node.id);
                                    childIds.forEach(id => next.delete(id));
                                    return next;
                                });
                            }
                            toggleParent();
                        }}
                    />
                </td>

                {/* COL 2: expander + name + sensitive (parent level only) */}
                <td className="cell name-col td_with_select_checkbox">
                    {hasChildren ? (
                        <button
                            type="button"
                            onClick={() => setOpen(o => !o)}
                        >
                            {open
                                ? <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1 1.5L6 6.5L11 1.5" stroke="#98A2B3" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                                : <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1.5 11L6.5 6L1.5 1" stroke="#98A2B3" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            }
                        </button>
                    ) : (
                        <></>
                    )}
                    <span className={`label ${!hasChildren ? "no-children m-0" : ""}`}>
                        {node.name}
                    </span>
                    {parentActive &&
                        <>
                            <div className="d-flex align-items-center">
                                <div className='primary_checkbox vertical_space_cls'>
                                    <Checkbox
                                        id={`checkbox_sensitive_${node.id}`}
                                        name={`checkbox_sensitive_${node.id}`}
                                        checked={sensitive[node.id]?.isChecked || false}
                                        onChange={() => handleSensitiveCheck(node.id)}
                                        disabled={isDisabled}
                                    >
                                        <span className="form_label">
                                            Allow under Custom condition
                                        </span>
                                    </Checkbox>
                                </div>

                                {sensitive[node.id]?.isChecked && (
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '2px', flex: '1' }} className='m_end_1'>
                                        <Select
                                            className="form_select basic no_search"
                                            showSearch={false}
                                            placeholder="Select your custom requirement to allow sensitive category"
                                            value={sensitive[node.id]?.selection || undefined}
                                            onChange={(val) => handleSensitiveSelect(node.id, val)}
                                            disabled={isDisabled}
                                            options={ACTIVATION_OPTIONS.map(opt => ({ label: opt, value: opt }))}
                                        />

                                    </div>
                                )}
                            </div>
                            {sensitive[node.id]?.isChecked && (
                                <>
                                    {attemptedIds.has(node.id) && !sensitive[node.id]?.selection && (
                                        <span className="error_content">This field is required</span>
                                    )}
                                </>
                            )}
                        </>
                    }
                </td>
            </tr>

            {/* Children rows */}
            {open &&
                (node.children || [])
                    .filter(ch => !searchTerm || ch.name.toLowerCase().includes(searchTerm))
                    .map(ch => (
                        <tr key={ch.id} className={selected.has(ch.id) ? "is-selected" : ""}>
                            {/* COL 1: empty — aligns children under parent name column */}
                            <td className="cell checkbox-col" />
                            {/* COL 2: switch + name (one level inside parent) */}
                            <td className="cell name-col child">
                                <Switch
                                    disabled={isDisabled}
                                    checked={selected.has(ch.id)}
                                    onChange={() => toggleChild(ch.id)}
                                />
                                <span className="label no-children m-0">{ch.name}</span>
                            </td>
                        </tr>
                    ))
            }
        </>
    );
}


const MyProfileV2 = (props) => {

    const { TextArea } = Input;

    const [countryOptionsGeo, setCountryOptionsGeo] = useState([]);



    const validateHeadersAndRows = (rows, template) => {
        // rows: array of objects with keys equal to header labels
        // template: the template object for chosen inventory type
        const headerMap = {}; // map header->key
        // Build map from template header strings to internal keys
        for (const [key, meta] of Object.entries(template)) headerMap[meta.header.trim()] = key;

        // Check all required headers exist in the sheet
        const sheetHeaders = rows.length > 0 ? Object.keys(rows[0]).map(h => h.trim()) : [];

        const missingHeaders = [];
        for (const meta of Object.values(template)) {
            if (meta.required && !sheetHeaders.includes(meta.header.trim())) {
                missingHeaders.push(meta.header);
            }
        }
        if (missingHeaders.length) {
            return { ok: false, errors: [`Missing required columns: ${missingHeaders.join(", ")}`] };
        }

        // Validate rows
        const errors = [];
        const normalizedRows = rows.map((row, rowIndex) => {
            const normalized = {};
            for (const [header, value] of Object.entries(row)) {
                const trimmedHeader = header.trim();
                const key = headerMap[trimmedHeader];
                if (!key) continue; // ignore unknown columns
                const meta = template[key];
                let cellVal = value;

                // Type checking
                if (meta.type === "number") {
                    if (cellVal === "" || cellVal === null) {
                        if (meta.required) errors.push(`Row ${rowIndex + 2}: ${meta.header} is required`); // +2 because sheet header + 1-based
                    } else if (isNaN(Number(cellVal))) {
                        errors.push(`Row ${rowIndex + 2}: ${meta.header} must be a number`);
                    } else {
                        cellVal = Number(cellVal);
                    }
                } else if (meta.type === "url") {
                    if (cellVal) {
                        const raw = String(cellVal).trim();
                        const domainLikeRegex = /([a-z0-9-]+\.[a-z0-9-.]+)/i;

                        if (!domainLikeRegex.test(raw)) {
                            errors.push(`Row ${rowIndex + 2}: ${meta.header} must contain a valid domain (e.g., example.com)`);
                        } else {
                            cellVal = raw; // keep original input
                        }
                    } else if (meta.required) {
                        errors.push(`Row ${rowIndex + 2}: ${meta.header} is required`);
                    }
                }
                else if (meta.type === "select") {
                    if (cellVal) {

                        let allowed = meta.options || [];
                        if (meta.header === "Geo") {
                            allowed = countryOptionsGeo?.map(
                                c => c.label.toLowerCase()
                            ) || [];
                        }
                        else {
                            allowed = meta.options || [];
                        }

                        if (!allowed.includes(String(cellVal).trim())) {
                            if (meta.header === "Geo") {
                                errors.push(`Row ${rowIndex + 2}: ${meta.header} is not a valid option.`);
                            }
                            else {
                                errors.push(`Row ${rowIndex + 2}: ${meta.header} must be one of: ${allowed.join(", ")}`);
                            }

                        }
                    } else if (meta.required) {
                        errors.push(`Row ${rowIndex + 2}: ${meta.header} is required`);
                    }
                }
                else { // text
                    if ((cellVal === "" || cellVal === null) && meta.required) {
                        errors.push(`Row ${rowIndex + 2}: ${meta.header} is required`);
                    }
                }

                normalized[key] = cellVal;
            }
            return normalized;
        });

        return { ok: errors.length === 0, normalizedRows, errors };
    };


    //--------------------------------------------------------------------------------------------------------------------------------------------
    const [inventoryType, setInventoryType] = useState("");
    const [inventoryCtvData, setInventoryCtvData] = useState([]);
    const [inventoryCtvName, setInventoryCtvName] = useState("");
    const [inventoryMobileData, setInventoryMobileData] = useState([]);
    const [inventoryMobileName, setInventoryMobileName] = useState("");
    const [inventoryWebsiteData, setInventoryWebsiteData] = useState([]);
    const [inventoryWebsiteName, setInventoryWebsiteName] = useState("");
    const [data, setData] = useState([]);
    const [form] = Form.useForm();
    const [editingKey, setEditingKey] = useState("");
    const [isMrt, setIsMrt] = useState(false);

    // Safe template lookup (guard when inventoryType not present)
    const template = useMemo(() => inventoryTemplates?.[inventoryType] ?? {}, [inventoryType]);

    // Build columns from template (memoized)
    // const mergedColumns = useMemo(() => {
    //     // If template is empty, return empty array
    //     return Object.entries(template).map(([key, meta]) => {
    //         return {
    //             title: meta.header ?? key,
    //             dataIndex: key,
    //             key,
    //             editable: meta.editable !== false,
    //             inputType: meta.type === "select" ? "select" : meta.type === "number" ? "number" : "text",
    //             options: meta.options ?? [],
    //             required: meta.required ?? false,
    //             render: (value) => (value === undefined || value === null ? "" : String(value)),
    //         };
    //     });
    // }, [template]);
    const mergedColumns = useMemo(() => {
        return Object.entries(template).map(([key, meta]) => {
            return {
                title: meta.header ?? key,
                dataIndex: key,
                key,
                editable: ((props.callFrom === "onboarding" || props.callFrom === "register") && (key === "app_bundle" || key === "domain" || key === "app_store_url")) ? true
                    : meta.editable !== false,
                inputType:
                    meta.type === "select"
                        ? "select"
                        : meta.type === "number"
                            ? "number"
                            : "text",
                options: meta.options ?? [],
                required: meta.required ?? false,

                // 🔥 CUSTOM RENDER FOR DOMAIN
                render: (value) => {
                    if (!value) return "";

                    if (key === "domain") {
                        return (
                            <a
                                href={value.includes("https://") ? value : "https://" + value}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text_primary"
                            >
                                {value}
                            </a>
                        );
                    }

                    return String(value);
                },
            };
        });
    }, [template, props.callFrom]);


    const mrtColumns = [
        {
            title: "Owner Domain",
            dataIndex: ["pixalate", "domainInfo", "ownerDomain"],
            key: "ownerDomain",
            onHeaderCell: () => ({
                className: 'border_right_0',
            }),
            render: (value, record) => {
                // 🚧 Under Processing state (same as IVT)
                if (!record.isMRTData) {
                    return (
                        <Tooltip title="Under Processing">
                            <img
                                src={InventoryProcessingLoader}
                                alt=""
                                className="inventory_processing_loader_img"
                            />
                        </Tooltip>
                    );
                }

                // ✅ Data available
                if (value === null || value === undefined) return "-";

                // Optional: if API returns array
                // if (Array.isArray(value)) {
                //     return value.length ? value.join(", ") : "-";
                // }

                return value;
            },
        },
        {
            title: "Risk",
            dataIndex: ["pixalate", "riskMetrics", "risk"],
            key: "risk",
            width: 110,
            onHeaderCell: () => ({
                className: 'border_right_0',
            }),
            render: (value, record) => {

                if (!record.isMRTData) {
                    return (
                        <Tooltip title="Under Processing">
                            <img
                                src={InventoryProcessingLoader}
                                alt=""
                                className="inventory_processing_loader_img"
                            />
                        </Tooltip>
                    );
                }

                if (value === null || value === undefined || value === "") return "-";

                if (value === "NA") return "NA";

                return (
                    <>
                        <div className='d-flex gap-3'>
                            {value === "low" ? <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect width="3" height="16" rx="1.5" fill="#0EA371" />
                                <rect x="6" width="3" height="16" rx="1.5" fill="#EAECF0" />
                                <rect x="12" width="3" height="16" rx="1.5" fill="#EAECF0" />
                            </svg>
                                :
                                value === "medium" ?
                                    <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect width="3" height="16" rx="1.5" fill="#FF8800" />
                                        <rect x="6" width="3" height="16" rx="1.5" fill="#FF8800" />
                                        <rect x="12" width="3" height="16" rx="1.5" fill="#EAECF0" />
                                    </svg>

                                    :
                                    <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect width="3" height="16" rx="1.5" fill="#D92D20" />
                                        <rect x="6" width="3" height="16" rx="1.5" fill="#D92D20" />
                                        <rect x="12" width="3" height="16" rx="1.5" fill="#D92D20" />
                                    </svg>

                            }

                            {value}
                        </div>
                    </>

                );
            }
        },

        {
            title: "IAB Primary Categories",
            dataIndex: ["pixalate", "categories", "iabPrimaryCategories"],
            key: "iabPrimaryCategories",
            onHeaderCell: () => ({
                className: 'border_right_0',
            }),
            render: (value, record) => {
                // 🚧 Under Processing state (same as IVT)
                if (!record.isMRTData) {
                    return (
                        <Tooltip title="Under Processing">
                            <img
                                src={InventoryProcessingLoader}
                                alt=""
                                className="inventory_processing_loader_img"
                            />
                        </Tooltip>
                    );
                }

                // ✅ Data available
                if (value === null || value === undefined) return "-";

                // Optional: if API returns array
                if (Array.isArray(value)) {
                    return value.length ? value.join(", ") : "-";
                }

                return value;
            },
        },

        {
            title: "IAB Subcategories",
            dataIndex: ["pixalate", "categories", "iabSubCategories"],
            key: "iabSubCategories",
            onHeaderCell: () => ({
                className: 'border_right_0',
            }),
            render: (value, record) => {
                // 🚧 Under Processing state (same as IVT)
                if (!record.isMRTData) {
                    return (
                        <Tooltip title="Under Processing">
                            <img
                                src={InventoryProcessingLoader}
                                alt=""
                                className="inventory_processing_loader_img"
                            />
                        </Tooltip>
                    );
                }

                // ✅ Data available
                if (value === null || value === undefined) return "-";

                // Optional: if API returns array
                if (Array.isArray(value)) {
                    return value.length ? value.join(", ") : "-";
                }

                return value;
            },
        },
        {
            title: "Rejection Reason",
            dataIndex: "rejectionReason",
            key: "rejectionReason",
            width: 120,
            onHeaderCell: () => ({
                className: 'border_right_0',
            }),
            render: (value) => {
                if (value === null || value === undefined || value === "") return "-";

                if (value === "NA") return "NA";

                return (
                    <>{value}</>

                );
            }
        },
        {
            title: "IVT",
            dataIndex: ["pixalate", "riskMetrics", "ivt"],
            key: "ivt",
            onHeaderCell: () => ({
                className: 'border_right_0',
            }),

            render: (value) => {
                if (value === null || value === undefined) return "-";

                if (value === "NA") return "NA";

                let colorClass = "--green";

                if (value > 20) {
                    colorClass = "--red";
                } else if (value > 10) {
                    colorClass = "--orange";
                }

                return (
                    <div className={`progress_bar_with_perc ${colorClass}`}>
                        <span>{value.toFixed(2)}%</span>
                        <Progress
                            percent={value}
                            showInfo={false}
                            size="small"
                        />
                    </div>
                );
            }


        },
        {
            title: "SIVT",
            dataIndex: ["pixalate", "riskMetrics", "sivt"],
            key: "sivt",
            render: (value) => {
                if (value === null || value === undefined) return "-";

                if (value === "NA") return "NA";

                let colorClass = "--green";

                if (value > 20) {
                    colorClass = "--red";
                } else if (value > 10) {
                    colorClass = "--orange";
                }

                return (
                    <div className={`progress_bar_with_perc ${colorClass}`}>
                        <span>{value.toFixed(2)}%</span>
                        <Progress
                            percent={value}
                            showInfo={false}
                            size="small"
                        />
                    </div>
                );
            }
        },
        {
            title: "GIVT",
            dataIndex: ["pixalate", "riskMetrics", "givt"],
            key: "givt",
            render: (value) => {
                if (value === null || value === undefined) return "-";

                if (value === "NA") return "NA";

                let colorClass = "--green";

                if (value > 20) {
                    colorClass = "--red";
                } else if (value > 10) {
                    colorClass = "--orange";
                }

                return (
                    <div className={`progress_bar_with_perc ${colorClass}`}>
                        <span>{value.toFixed(2)}%</span>
                        <Progress
                            percent={value}
                            showInfo={false}
                            size="small"
                        />
                    </div>
                );
            }
        },
        {
            title: "Viewability",
            dataIndex: ["pixalate", "riskMetrics", "viewability"],
            key: "viewability",
            // render: (value) => value ?? "-"

            render: (value) => {
                if (value === null || value === undefined) return "-";
                if (value === "NA") return "NA";
                return (
                    <div className='viewability_percent'>
                        <Progress percent={value} size="small" />
                    </div>
                );
            }
        },
        {
            title: "Made For Advertising (MFA) Risk",
            key: "mfaRisk",
            children: [
                {
                    title: "MFA Risk",
                    dataIndex: ["pixalate", "mfaRisk", "mfaRisk"],
                    key: "mfaRisk",
                    render: (value) => value ?? "-"
                },
                {
                    title: "Ad Refresh Rate",
                    dataIndex: ["pixalate", "mfaRisk", "adRefreshRate"],
                    key: "adRefreshRate",
                    render: (value) => value ?? "-"
                },
                {
                    title: "Ad Density",
                    dataIndex: ["pixalate", "mfaRisk", "adDensity"],
                    key: "adDensity",
                    render: (value) => value ?? "-"
                },
                {
                    title: "Social Traffic Rate",
                    dataIndex: ["pixalate", "mfaRisk", "socialTrafficRate"],
                    key: "socialTrafficRate",
                    render: (value) => value ?? "-"
                },
                {
                    title: "Paid Traffic Rate",
                    dataIndex: ["pixalate", "mfaRisk", "paidTrafficRate"],
                    key: "paidTrafficRate",
                    render: (value) => value ?? "-"
                }
            ]
        },
        {
            title: "Traffic Quality Risk",
            key: "trafficQualityRisk",
            children: [
                {
                    title: "Ad Fraud (IVT)",
                    dataIndex: ["pixalate", "trafficQualityRisk", "adFraudIvtRisk"],
                    key: "adFraudIvtRisk",
                    render: (value) => value ?? "-"
                },
                {
                    title: "Click Fraud",
                    dataIndex: ["pixalate", "trafficQualityRisk", "clickFraudRisk"],
                    key: "clickFraudRisk",
                    render: (value) => value ?? "-"
                },
                {
                    title: "Viewability Risk",
                    dataIndex: ["pixalate", "trafficQualityRisk", "viewabilityRisk"],
                    key: "viewabilityRisk",
                    render: (value) => value ?? "-"
                },
                {
                    title: "Domain Masking",
                    dataIndex: ["pixalate", "trafficQualityRisk", "domainMaskingRisk"],
                    key: "domainMaskingRisk",
                    render: (value) => value ?? "-"
                },
                {
                    title: "Major Traffic Source",
                    dataIndex: ["pixalate", "trafficQualityRisk", "majorTrafficSource"],
                    key: "majorTrafficSource",
                    render: (value) => value ?? "-"
                }
            ]
        },
        {
            title: "Brand Safety Risk",
            key: "brandSafetyRisk",
            children: [
                {
                    title: "Brand Safety Risk",
                    dataIndex: ["pixalate", "brandSafetyRisk", "brandSafetyRisk"],
                    key: "brandSafetyRisk",
                    render: (value) => value ?? "-"
                },
                {
                    title: "Adult Content",
                    dataIndex: ["pixalate", "brandSafetyRisk", "adultContent"],
                    key: "adultContent",
                    render: (value) => value ?? "-"
                },
                {
                    title: "Alcohol Content",
                    dataIndex: ["pixalate", "brandSafetyRisk", "alcoholContent"],
                    key: "alcoholContent",
                    render: (value) => value ?? "-"
                },
                {
                    title: "Drug Content",
                    dataIndex: ["pixalate", "brandSafetyRisk", "drugContent"],
                    key: "drugContent",
                    render: (value) => value ?? "-"
                },
                {
                    title: "Hate Speech",
                    dataIndex: ["pixalate", "brandSafetyRisk", "hateSpeech"],
                    key: "hateSpeech",
                    render: (value) => value ?? "-"
                },
                {
                    title: "Phishing",
                    dataIndex: ["pixalate", "brandSafetyRisk", "phishing"],
                    key: "phishing",
                    render: (value) => value ?? "-"
                },
                {
                    title: "Malware",
                    dataIndex: ["pixalate", "brandSafetyRisk", "malware"],
                    key: "malware",
                    render: (value) => value ?? "-"
                }
            ]
        },
        {
            title: "Site Risk",
            key: "siteRisk",
            children: [
                {
                    title: "Domain Age",
                    dataIndex: ["pixalate", "siteRisk", "domainAge"],
                    key: "domainAge",
                    render: (value) => value ?? "-"
                },
                {
                    title: "Privacy Policy Detected",
                    dataIndex: ["pixalate", "siteRisk", "privacyPolicyDetected"],
                    key: "privacyPolicyDetected",
                    render: (value) => value ?? "-"
                },
                {
                    title: "Terms and Conditions Detected",
                    dataIndex: ["pixalate", "siteRisk", "termsAndConditionsDetected"],
                    key: "termsAndConditionsDetected",
                    render: (value) => value ?? "-"
                },
                {
                    title: "Ad Injection",
                    dataIndex: ["pixalate", "siteRisk", "adInjectionRisk"],
                    key: "adInjectionRisk",
                    render: (value) => value ?? "-"
                }

            ]
        }
    ];

    // Add Actions column
    const columnsWithActions = useMemo(() => {
        const cols = [{
            title: "Actions",
            dataIndex: "actions",
            key: "actions",
            render: (_text, record) => {
                const editable = isEditing(record);
                return editable ? (


                    < span className='save_cancel_btn_group' >
                        <Typography.Link onClick={() => save(record.key)}>
                            <Tooltip title="Save">
                                <div className='table_data_save_btn'>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                        <path d="M11.6663 3.5L5.24967 9.91667L2.33301 7" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                            </Tooltip>
                        </Typography.Link>


                        <Typography.Link onClick={cancel}>
                            <Tooltip title="Cancel">
                                <div className='table_data_cancel_btn'>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                        <path d="M10.5 3.5L3.5 10.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M3.5 3.5L10.5 10.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                            </Tooltip>
                        </Typography.Link>
                    </span >

                ) : (
                    <Typography.Link
                        disabled={editingKey !== ""} onClick={() => edit(record)}

                        style={{
                            pointerEvents: isDisabled ? "none" : "auto",
                            opacity: isDisabled ? 0.5 : 1,
                            cursor: isDisabled ? "not-allowed" : "pointer"
                        }}
                    >
                        <Tooltip title="Edit">
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                <g clipPath="url(#clip0_8365_16742)">
                                    <path d="M11.667 8.55158V11.6666C11.667 11.976 11.5441 12.2728 11.3253 12.4915C11.1065 12.7103 10.8097 12.8333 10.5003 12.8333H2.33366C2.02424 12.8333 1.72749 12.7103 1.5087 12.4915C1.28991 12.2728 1.16699 11.976 1.16699 11.6666V3.49992C1.16699 3.1905 1.28991 2.89375 1.5087 2.67496C1.72749 2.45617 2.02424 2.33325 2.33366 2.33325H5.44866" stroke="#98A2B3" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M10.5003 1.16675L12.8337 3.50008L7.00033 9.33341H4.66699V7.00008L10.5003 1.16675Z" stroke="#98A2B3" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_8365_16742">
                                        <rect width="14" height="14" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </Tooltip>
                    </Typography.Link>

                );
            },
        },
        ...mergedColumns.map((col) => {
            if (!col.editable) return col;
            return {
                ...col,
                width: col.dataIndex === "geo" ? 220 : col.width,
                onCell: (record) => ({
                    record,
                    inputType: col.inputType,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    editing: isEditing(record),
                    required: col.required,
                    options: col.dataIndex === "geo"
                        ? countryOptionsGeo : col.options,
                }),
            };
        }),

        ];
        // return cols;

        let baseColumns = [...cols];

        // ✅ Append MRT columns ONLY for Website + isMRT
        if (isMrt === true && inventoryType === "Website" &&
            props.callFrom !== "onboarding") {
            baseColumns = [...baseColumns, ...mrtColumns];
        }

        return baseColumns;

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mergedColumns, editingKey, isMrt, inventoryType]); // depends on editingKey too

    // const components = { body: { cell: EditableCell } }; // unused
    // const tableColumns = columnsWithActions.map(...); // unused


    const isEditing = (record) => String(record.key) === String(editingKey);

    const edit = (record) => {
        // build normalizedFields so Select sees string values and InputNumber gets numbers
        const normalized = { ...record };

        // assume you have mergedColumns or template in scope
        mergedColumns.forEach((col) => {
            const key = col.dataIndex;
            if (!(key in normalized)) return;

            if (col.dataIndex === "geo") {
                const match = countryOptionsGeo.find(
                    c => c.label.toLowerCase() === String(normalized[key]).toLowerCase()
                );
                normalized[key] = match ? match.value : "";
            }

            else if (col.inputType === "select") {
                // coerce select values to string (matches Select.Option value above)
                normalized[key] = normalized[key] == null ? "" : String(normalized[key]);
            } else if (col.inputType === "number") {
                const v = normalized[key];
                normalized[key] = v === "" || v === null || v === undefined ? undefined : Number(v);
            } else {
                // trim text fields optionally
                normalized[key] = normalized[key] == null ? "" : normalized[key];
            }
        });

        form.setFieldsValue(normalized);
        setEditingKey(record.key);
    };

    const cancel = () => {
        form.resetFields();
        setEditingKey("");
    };

    const save = async (key) => {
        try {
            // validate only current form fields
            const row = await form.validateFields(); // returns { columnName: value, ... }

            let newData;
            if (inventoryType === "Website") {
                newData = [...inventoryWebsiteData];
            }
            else if (inventoryType === "Mobile App (Android / iOS)") {
                newData = [...inventoryMobileData];
            }
            else if (inventoryType === "CTV / FAST Apps") {
                newData = [...inventoryCtvData];
            }


            const idx = newData.findIndex((item) => String(item.key) === String(key));
            if (idx > -1) {
                const item = newData[idx];
                newData.splice(idx, 1, { ...item, ...row, pixalate: item.pixalate });
                if (inventoryType === "Website") {

                    setInventoryWebsiteData(newData);
                }
                else if (inventoryType === "Mobile App (Android / iOS)") {
                    setInventoryMobileData(newData);
                }
                else if (inventoryType === "CTV / FAST Apps") {
                    setInventoryCtvData(newData);
                }


                setEditingKey("");
                notifysuccess("Data saved successfully");
            } else {
                // fallback: push
                const newRow = { key: Date.now().toString(), ...row };
                newData.push(newRow);
                if (inventoryType === "Website") {

                    setInventoryWebsiteData(newData);
                }
                else if (inventoryType === "Mobile App (Android / iOS)") {
                    setInventoryMobileData(newData);
                }
                else if (inventoryType === "CTV / FAST Apps") {
                    setInventoryCtvData(newData);
                }
                setEditingKey("");
                notifysuccess("Data saved successfully");
            }
        } catch (err) {
            // console.log("Validate Failed:", err);
            notifyfailure("Validation failed");
        }
    };

    // Add new empty row matching template
    // const handleAdd = () => {
    //     const newRow = { key: Date.now().toString() };
    //     Object.keys(template).forEach((k) => {
    //         newRow[k] = "";
    //     });
    //     setData((prev) => [...prev, newRow]);
    // };

    // When inventoryType (template) changes, map existing rows -> keep overlapping fields
    useEffect(() => {
        setEditingKey("");
        // If there is no previous data, create a single empty row
        if (!data || data.length === 0) {
            const emptyRow = { key: Date.now().toString() };
            Object.keys(template).forEach((k) => (emptyRow[k] = ""));
            setData([emptyRow]);
            return;
        }

        // Map existing rows to new template keys
        // const mapped = data.map((row) => {
        //     const newRow = { key: row.key ?? Date.now().toString() };
        //     Object.keys(template).forEach((k) => {
        //         // preserve value if key exists in old row, otherwise set empty string
        //         newRow[k] = row.hasOwnProperty(k) ? row[k] : "";
        //     });
        //     return newRow;
        // });

        // setData(mapped);

        const mapped = data.map(row => {
            const newRow = {
                key: row.key,
                pixalate: row.pixalate // ✅ preserve pixalate
            };

            Object.keys(template).forEach(k => {
                newRow[k] = row[k] ?? "";
            });

            return newRow;
        });

        setData(mapped);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inventoryType]); // intentionally only depend on inventoryType

    // File upload handler (keeps your original behavior but ensures unique keys)
    const handleBeforeUpload = async (file, fileType) => {

        const accepted = ["xlsx", "xls", "csv"];
        const ext = file.name.split(".").pop().toLowerCase();
        if (!accepted.includes(ext)) {
            notifyfailure("Only Excel/CSV files are allowed");
            return Upload.LIST_IGNORE;
        }

        try {
            const rows = await parseExcelFile(file);
            if (!rows || rows.length === 0) {
                notifyfailure("The file appears to be empty or the format is not recognized.");
                return Upload.LIST_IGNORE;
            }

            const { ok, normalizedRows, errors } = validateHeadersAndRows(rows, inventoryTemplates[fileType]);
            if (!ok) {
                errors.forEach((err) => notifyfailure(err, 5));
                return Upload.LIST_IGNORE;
            }

            // Convert normalizedRows to table format with a unique key
            const prepared = normalizedRows.map((r, idx) => ({ key: Date.now().toString() + "_" + idx, ...r }));

            // console.log(prepared)

            if (fileType === "Website") {
                setInventoryWebsiteData(prepared)
                setInventoryWebsiteName(file.name)
            }
            else if (fileType === "CTV / FAST Apps") {
                setInventoryCtvData(prepared)
                setInventoryCtvName(file.name)
            }
            else if (fileType === "Mobile App (Android / iOS)") {
                setInventoryMobileData(prepared)
                setInventoryMobileName(file.name)
            }

            // setData(prepared);
            notifysuccess("File imported and validated successfully");
        } catch (err) {
            // console.error(err);
            notifyfailure("Failed to parse file: " + (err.message || err));
        }

        // prevent antd from auto posting file
        return Upload.LIST_IGNORE;
    };


    //----------------------------------------------------------------------------------------------------------------------------------------------


    const [show, setShow] = useState(false);

    const handleClose = () => { setShow(false); setEditingKey("") }
    const handleShow = (data) => { setShow(true); setInventoryType(data) };


    //----------------------------------------category related code --------------------------------------------------------------------------------
    // const [checkRole, setCheckRole] = useState("admin");
    const [DATA, setDATA] = useState([
        // {
        //     id: "IAB1",
        //     name: "Arts & Entertainment",
        //     children: [],
        // },
        // {
        //     id: "IAB7",
        //     name: "Health & Fitness",
        //     children: [
        //         { id: "IAB7-1", name: "Exercise" },
        //         { id: "IAB7-2", name: "A.D.D." },
        //         { id: "IAB7-3", name: "AIDS/HIV" },
        //         { id: "IAB7-4", name: "Allergies" },
        //         { id: "IAB7-5", name: "Alternative Medicine" },
        //     ],
        // },
        // {
        //     id: "IAB25",
        //     name: "Non-Standard Content",
        //     children: [
        //         { id: "IAB25-1", name: "Unmoderated UGC" },
        //         { id: "IAB25-2", name: "Extreme Graphic/Explicit Violence" },
        //         { id: "IAB25-3", name: "Pornography" },
        //         { id: "IAB25-4", name: "Profane Content" },
        //         { id: "IAB25-5", name: "Hate Content" },
        //     ],
        // },
        // {
        //     id: "IAB26",
        //     name: "Illegal Content",
        //     children: [
        //         { id: "IAB26-1", name: "Illegal Downloads" },
        //         { id: "IAB26-2", name: "Illegal Drugs" },
        //         { id: "IAB26-3", name: "Hate Content" },
        //         { id: "IAB26-4", name: "Weapons" },
        //     ],
        // },
    ]);
    const [selected, setSelected] = useState(new Set());
    const [selectedTrack, setSelectedTrack] = useState(new Set());
    const [sensitive, setSensitive] = useState({});
    const [sensitiveAttemptedIds, setSensitiveAttemptedIds] = useState(new Set());
    const [search, setSearch] = useState("");
    const masterRef = useRef(null);
    const searchTerm = search.trim().toLowerCase();
    const parentIds = useMemo(() => DATA.map(node => node.id), [DATA]);
    const allSelectedAll = parentIds.every(id => selected.has(id));
    const someSelectedAll = !allSelectedAll && parentIds.some(id => selected.has(id));

    // "Block all sensitive categories" checkbox
    const blockAllChecked = SENSITIVE_BLOCK_IDS.every(id => selected.has(id));
    const handleBlockAll = () => {
        setSelected(prev => {
            const next = new Set(prev);
            if (blockAllChecked) {
                SENSITIVE_BLOCK_IDS.forEach(id => next.delete(id));
            } else {
                SENSITIVE_BLOCK_IDS.forEach(id => next.add(id));
            }
            return next;
        });
    };
    const visibleNodes = DATA.filter(node => {
        const parentMatches = node.name.toLowerCase().includes(searchTerm.toLowerCase());
        const childMatches = (node.children || []).some(c =>
            c.name.toLowerCase().includes(searchTerm.toLowerCase())
        );
        return !searchTerm || parentMatches || childMatches;
    });

    // eslint-disable-next-line no-unused-vars
    function getSelectedChildrenCount(options, selected) {
        let count = 0;

        function findNodeById(nodes, id) {
            for (const node of nodes) {
                if (node.id === id) return node;
                if (node.children) {
                    const found = findNodeById(node.children, id);
                    if (found) return found;
                }
            }
            return null;
        }

        for (const id of selected) {
            const node = findNodeById(options, id);
            if (node) {
                if (node.children && node.children.length > 0) {
                    // parent selected → add number of children
                    count += node.children.length;
                } else {
                    // child selected → count 1
                    count += 1;
                }
            }
        }

        return count;
    }

    useEffect(() => {
        if (masterRef.current) {
            masterRef.current.indeterminate = someSelectedAll;
        }
    }, [someSelectedAll]);

    // eslint-disable-next-line no-unused-vars
    const handleMaster = () => {
        setSelected(prev => {
            const next = new Set();

            if (allSelectedAll) {
                // uncheck all
                return next;
            } else {
                // select only parent IDs (not children individually)
                DATA.forEach(node => {
                    next.add(node.id);
                });
            }

            return next;
        });
    };

    // function getSelectedChildrenCount(options, selected) { ... } // duplicate - defined above

    //--------------------------------------------------------main code starts from here---------------------------------------------------------------


    useEffect(() => {
        const inputs = document.querySelectorAll('.ant-select-selection-search-input');

        inputs.forEach(input => {
            const handleInput = () => {
                const parent = input.closest('.ant-select-selection-search');
                if (input.value.length > 0) {
                    parent.classList.add('searching');
                } else {
                    parent.classList.remove('searching');
                }
            };

            input.addEventListener('input', handleInput);

            // Cleanup event listener on component unmount
            return () => {
                input.removeEventListener('input', handleInput);
            };
        });
    });

    useEffect(() => {

        if (
            // props.signupData &&
            // typeof props.signupData === "object" &&
            // Object.keys(props.signupData).length !== 0
            props.callFrom === "register"

        ) {
            setName(props.signupData.p_name)
            setCompanyName(props.signupData.o_name)
            setEmail(props.signupData.email)
            setCompanyWebsite(props.signupData.c_website)
            if (
                props.signupData.im &&
                typeof props.signupData.im === "object" &&
                Object.keys(props.signupData.im).length !== 0
            ) {
                const imKey = Object.keys(props.signupData.im)[0];
                const imValue = props.signupData.im[imKey];

                setSelectedIm(imKey);
                setIm(imValue);

            }

        }


        else if (props.callFrom === "onboarding" || props.callFrom === "profile" || props.callFrom === "listing") {



            let status = Cookies.get("token_xapads_ssp") ? true : false;
            if (status) {
                let token = Cookies.get("token_xapads_ssp");
                // setCheckRole(jwtDecode(token).role)
                axios
                    .get((configData.SERVER_URL + "ops/getPubDetails?_id=" + (props.callFrom === "listing" ? props.id : "")), {
                        headers: {
                            "Content-Type": "application/json",
                            "x-access-token": token,
                        },
                    })
                    .then((response) => {

                        if (props.callFrom === "onboarding") {

                            if (response?.data?.data?.onboard_filled && (response?.data?.data?.status === "onboard" || response?.data?.data?.status === "rejected")) {
                                setIsDisabled(true)
                            }

                        }

                        setCurrentStatus(response?.data?.data?.status)

                        setName(response?.data?.data?.p_name || "");
                        setPoc(response?.data?.data?.poc || "");
                        setCompanyName(response?.data?.data?.o_name || "");
                        setCompanyWebsite(response?.data?.data?.c_website || "");
                        setEmail(response?.data?.data?.email || "");
                        setSelectedIm(response?.data?.data?.im?.label || "");
                        setIm(response?.data?.data?.im?.value || "");
                        setCountry(response?.data?.data?.address?.country || "");
                        setCompanyLinkedin(response?.data?.data?.o_contact || "");

                        setImportUrl(response?.data?.data?.media_link || "");

                        setDefineYourself(response?.data?.data?.defineYourself || [])
                        setIsMrt(response?.data?.data?.isMRT ?? false)
                        setIsMcm(response?.data?.data?.isMcm ?? null)
                        setGamEmail(response?.data?.data?.gamEmail || "")
                        setGamNetworkId(response?.data?.data?.gamNetworkCode || "")

                        setInventoryMonetize(response?.data?.data?.inventory_type_select || [])
                        setInventoryMonetizeOther(response?.data?.data?.inventory_type_select_other || "")
                        setInventoryMonetizeWebsiteUserSync(response?.data?.data?.inventory_type_select_website_usersync ?? null)
                        setInventoryMonetizeWebsiteBanner(response?.data?.data?.inventory_type_select_website_bannerPlacement ?? null)

                        setAdFormatMonetize(response?.data?.data?.ad_format_monetise || [])
                        setAdFormatMonetizeOther(response?.data?.data?.ad_format_monetise_other || "")

                        setIntegrationType(response?.data?.data?.integration_type || [])
                        setPrebidQuestion(response?.data?.data?.prebidQuestion || "")
                        setOrtbQuestion(response?.data?.data?.ortbQuestion || "")
                        setOrtbType(response?.data?.data?.ortb_type || [])
                        setVastType(response?.data?.data?.vast_type || [])


                        setIntegrationProtocolPlayer(response?.data?.data?.integration_protocol_player || "")
                        setIntegrationProtocolMime(response?.data?.data?.integration_protocol_mime || "")
                        setIntegrationProtocolTimeout(response?.data?.data?.integration_protocol_timeout || "")
                        setIntegrationProtocolAdserver(response?.data?.data?.integration_protocol_adserver || "")
                        setIntegrationProtocolImpression(response?.data?.data?.integration_protocol_impression ?? null)
                        setIntegrationProtocolBidrequest(response?.data?.data?.integration_protocol_bidrequest || "")
                        setIntegrationProtocolUid(response?.data?.data?.integration_protocol_uid ?? null)
                        setIntegrationProtocolRichMedia(response?.data?.data?.integration_protocol_rich_media ?? null)
                        setIntegrationProtocolRichMediaCreative(response?.data?.data?.integration_protocol_rich_media_creative || [])

                        setRegulationTool(response?.data?.data?.regulation_brand_safety_tool || "")
                        setRegulationAdserver(response?.data?.data?.regulation_brand_safety_adserver || "")
                        setRegulationParameter(response?.data?.data?.regulation_brand_safety_regulator || [])
                        setRegulationParameterOther(response?.data?.data?.regulation_brand_safety_regulator_other || "")

                        setSelected(new Set(response?.data?.data?.blockCategory) || new Set())
                        setSelectedTrack(new Set(response?.data?.data?.blockCategory) || new Set())
                        setSensitive(response?.data?.data?.bcate_data || {})

                        setSellerType(response?.data?.data?.s_type || "")
                        setSellerName(response?.data?.data?.s_name || "")
                        setSellerDomain(response?.data?.data?.s_domain || "")
                        setIsSellerPassThroughCheckbox(response?.data?.data?.isSellerPassThrough_checkbox || false)

                        setInventoryWebsiteData(response?.data?.data?.inventoryWebsiteData || [])
                        setInventoryWebsiteName(response?.data?.data?.inventoryWebsiteName || "")
                        setInventoryMobileData(response?.data?.data?.inventoryMobileData || [])
                        setInventoryMobileName(response?.data?.data?.inventoryMobileName || "")
                        setInventoryCtvData(response?.data?.data?.inventoryCtvData || [])
                        setInventoryCtvName(response?.data?.data?.inventoryCtvName || "")

                        setMediakit2(response?.data?.data?.mediaKit || [])

                        // setFormVisible(true)
                    })
                    .catch((error) => {
                        // setFormVisible(true)
                        notifyfailure("Failed to fetch the publisher details.")
                    });
            }
        }


        if (props.callFrom !== "profile") {
            axios
                .get(configData.SERVER_URL + "ops/inventoryCountryList")
                .then(res => {
                    // if (res.data?.status) {
                    setCountryOptionsGeo(res.data.data); // label/value array
                    // }
                })
                .catch(() => { });
        }



    }, [props])

    useEffect(() => {

        axios
            .get(configData.SERVER_URL + "user/countryList", {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                setCountryOptions(response.data.data);
            })
            .catch((error) => { });

        axios
            .get(configData.SERVER_URL + "user/iabCat", {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                setDATA(response.data.data);
            })
            .catch((error) => { });

    }, [])

    // Normalize blockCategory: API may return parent IDs (e.g. "IAB9") instead of children.
    // Expand any parent ID that has children in DATA to its child IDs.
    // Uses selectedTrack (set only from server) so user toggles don't re-trigger this.
    // Handles race condition: fires when either DATA or server data loads first.
    useEffect(() => {
        if (!DATA || DATA.length === 0) return;
        setSelected(prev => {
            const next = new Set();
            prev.forEach(id => {
                const parent = DATA.find(cat => cat.id === id);
                if (parent && parent.children && parent.children.length > 0) {
                    parent.children.forEach(ch => next.add(ch.id));
                } else {
                    next.add(id);
                }
            });
            return next;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [DATA, selectedTrack]);

    const [buttonValue, setButtonValue] = useState(false);

    const [isDisabled, setIsDisabled] = useState(false);
    const [currentStatus, setCurrentStatus] = useState("");

    const [name, setName] = useState("");
    const [nameIsRequiredError, setNameIsRequiredError] = useState(false);

    const [poc, setPoc] = useState("");
    const [pocIsRequiredError, setPocIsRequiredError] = useState(false);

    const [companyName, setCompanyName] = useState("");
    const [companyNameIsRequiredError, setCompanyNameIsRequiredError] =
        useState(false);

    const [email, setEmail] = useState("");
    // const [emailIsRequiredError, setEmailIsRequiredError] = useState(false);
    // const [emailUrlError, setEmailUrlError] = useState(false);

    const [companyWebsite, setCompanyWebsite] = useState("");
    const [companyWebsiteIsRequiredError, setCompanyWebsiteIsRequiredError] =
        useState(false);
    const [companyWebsiteUrlError, setCompanyWebsiteUrlError] = useState(false);

    const [im, setIm] = useState("");
    const [imIsRequiredError, setImIsRequiredError] = useState(false);

    const [selectedIm, setSelectedIm] = useState("telegram");

    const [countryOptions, setCountryOptions] = useState([]);
    const [country, setCountry] = useState("");
    const [countryIsRequiredError, setCountryIsRequiredError] = useState(false);

    const [companyLinkedin, setCompanyLinkedin] = useState("");
    const [companyLinkedinUrlError, setCompanyLinkedinUrlError] = useState(false);

    const [mediakit, setMediakit] = useState([]);
    const [mediakit2, setMediakit2] = useState([]);
    const [importUrl, setImportUrl] = useState("");
    const [importUrlError, setImportUrlError] = useState(false);

    const [defineYourself, setDefineYourself] = useState([]);
    const [defineYourselfIsRequiredError, setDefineYourselfIsRequiredError] = useState(false);

    const [isMcm, setIsMcm] = useState(null);
    const [isMcmIsRequiredError, setIsMcmIsRequiredError] = useState(false);
    const [gamEmail, setGamEmail] = useState("");
    const [gamEmailIsRequiredError, setGamEmailIsRequiredError] = useState(false);
    const [gamEmailUrlError, setGamEmailUrlError] = useState(false);
    const [gamNetworkId, setGamNetworkId] = useState("");
    const [gamNetworkIdIsRequiredError, setGamNetworkIdIsRequiredError] = useState(false);

    const [inventoryMonetize, setInventoryMonetize] = useState([]);
    const [inventoryMonetizeIsRequiredError, setInventoryMonetizeIsRequiredError] = useState(false);
    const [inventoryMonetizeOther, setInventoryMonetizeOther] = useState("");
    const [inventoryMonetizeOtherIsRequiredError, setInventoryMonetizeOtherIsRequiredError] = useState(false);
    const [inventoryMonetizeWebsiteUserSync, setInventoryMonetizeWebsiteUserSync] = useState(null);
    const [inventoryMonetizeWebsiteUserSyncIsRequiredError, setInventoryMonetizeWebsiteUserSyncIsRequiredError] = useState(false);
    const [inventoryMonetizeWebsiteBanner, setInventoryMonetizeWebsiteBanner] = useState(null);
    const [inventoryMonetizeWebsiteBannerIsRequiredError, setInventoryMonetizeWebsiteBannerIsRequiredError] = useState(false);

    const [integrationType, setIntegrationType] = useState([]);
    const [integrationTypeIsRequiredError, setIntegrationTypeIsRequiredError] = useState(false);
    const [prebidQuestion, setPrebidQuestion] = useState("");
    const [prebidQuestionIsRequiredError, setPrebidQuestionIsRequiredError] = useState(false)
    const [ortbType, setOrtbType] = useState([]);
    const [ortbTypeIsRequiredError, setOrtbTypeIsRequiredError] = useState(false);
    const [ortbQuestion, setOrtbQuestion] = useState("");
    const [ortbQuestionIsRequiredError, setOrtbQuestionIsRequiredError] = useState(false)
    const [vastType, setVastType] = useState([]);
    const [vastTypeIsRequiredError, setVastTypeIsRequiredError] = useState(false);

    const [adFormatMonetize, setAdFormatMonetize] = useState([]);
    const [adFormatMonetizeIsRequiredError, setAdFormatMonetizeIsRequiredError] = useState(false);
    const [adFormatMonetizeOther, setAdFormatMonetizeOther] = useState("");
    const [adFormatMonetizeOtherIsRequiredError, setAdFormatMonetizeOtherIsRequiredError] = useState(false);

    const [integrationProtocolPlayer, setIntegrationProtocolPlayer] = useState("");
    const [integrationProtocolMime, setIntegrationProtocolMime] = useState("");
    const [integrationProtocolMimeIsRequiredError, setIntegrationProtocolMimeIsRequiredError] = useState(false);
    const [integrationProtocolTimeout, setIntegrationProtocolTimeout] = useState("");
    const [integrationProtocolAdserver, setIntegrationProtocolAdserver] = useState("");
    const [integrationProtocolImpression, setIntegrationProtocolImpression] = useState(null);
    const [integrationProtocolBidrequest, setIntegrationProtocolBidrequest] = useState("");
    const [integrationProtocolUid, setIntegrationProtocolUid] = useState(null);
    const [integrationProtocolRichMedia, setIntegrationProtocolRichMedia] = useState(null);
    const [integrationProtocolRichMediaIsRequiredError, setIntegrationProtocolRichMediaIsRequiredError] = useState(false);
    const [integrationProtocolRichMediaCreative, setIntegrationProtocolRichMediaCreative] = useState([]);

    const [regulationTool, setRegulationTool] = useState("");
    const [regulationToolIsRequiredError, setRegulationToolIsRequiredError] = useState(false);
    const [regulationAdserver, setRegulationAdserver] = useState("");
    const [regulationAdserverIsRequiredError, setRegulationAdserverIsRequiredError] = useState(false);
    const [regulationParameter, setRegulationParameter] = useState([]);
    const [regulationParameterIsRequiredError, setRegulationParameterIsRequiredError] = useState(false);
    const [regulationParameterOther, setRegulationParameterOther] = useState("");
    const [regulationParameterOtherIsRequiredError, setRegulationParameterOtherIsRequiredError] = useState(false);

    const [sellerType, setSellerType] = useState("");
    const [sellerTypeIsRequiredError, setSellerTypeIsRequiredError] = useState(false);
    const [sellerName, setSellerName] = useState("");
    const [sellerNameIsRequiredError, setSellerNameIsRequiredError] =
        useState(false);
    const [sellerDomain, setSellerDomain] = useState("");
    const [sellerDomainIsRequiredError, setSellerDomainIsRequiredError] =
        useState(false);
    const [sellerDomainUrlError, setSellerDomainUrlError] = useState(false);
    const [isSellerPassThroughCheckbox, setIsSellerPassThroughCheckbox] =
        useState(false);


    const validateEmail = (email) => {
        return String(email)
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
    };

    const validateWebsiteUrl = (websiteUrl) => {
        return String(websiteUrl)
            .toLowerCase()
            .match(/.+[.].+/);
    };

    const validateLinkedinUrl = (linkedinUrl) => {
        return String(linkedinUrl)
            .toLowerCase()
            .match(/^(https?:\/\/)?([^/]+\.)?(linkedin\.[a-zA-Z]+\/.*)$/);
    };

    function onChangeName(event) {
        setNameIsRequiredError(false);
        setName(event.target.value);
    }

    function onBlurName(event) {
        if (event.target.value.trim().length === 0) {
            setNameIsRequiredError(true);
        }
        setName(event.target.value.trim());
    }

    function onChangePoc(event) {
        setPocIsRequiredError(false);
        setPoc(event.target.value);
    }

    function onBlurPoc(event) {
        if (event.target.value.trim().length === 0) {
            setPocIsRequiredError(true);
        }
        setPoc(event.target.value.trim());
    }

    function onChangeCompanyName(event) {
        setCompanyNameIsRequiredError(false);
        setCompanyName(event.target.value);
    }

    function onBlurCompanyName(event) {
        if (event.target.value.trim().length === 0) {
            setCompanyNameIsRequiredError(true);
            setCompanyName("");
        }
        setCompanyName(event.target.value.trim());
    }

    // function onChangeEmail(event) { ... } // unused
    // function onBlurEmail(event) { ... } // unused

    function onChangeIm(event) {
        setImIsRequiredError(false);
        setIm(event.target.value);
    }

    function onBlurIm(event) {
        if (event.target.value.trim().length === 0) {
            setImIsRequiredError(true);
        }
        setIm(event.target.value.trim());
    }

    function onChangeSelectedIm(event) {
        setSelectedIm(event);
    }

    function onChangeCompanyWebsite(event) {
        setCompanyWebsite(event.target.value);

        if (event.target.value.length === 0) {
            setCompanyWebsiteUrlError(false);
            setCompanyWebsiteIsRequiredError(true);
        } else {
            setCompanyWebsiteIsRequiredError(false);

            if (validateWebsiteUrl(event.target.value) === null) {
                setCompanyWebsiteUrlError(true);
            } else {
                setCompanyWebsiteUrlError(false);
            }
        }
    }

    function onBlurCompanyWebsite(event) {
        if (event.target.value.trim().length === 0) {
            setCompanyWebsiteUrlError(false);
            setCompanyWebsiteIsRequiredError(true);
        } else {
            if (validateWebsiteUrl(event.target.value.trim()) === null) {
                setCompanyWebsiteUrlError(true);
            } else {
                setCompanyWebsiteUrlError(false);
            }
        }
        setCompanyWebsite(event.target.value.trim());
    }


    function onChangeImportUrl(event) {
        setImportUrl(event.target.value);

        if (event.target.value.length === 0) {
            setImportUrlError(false);

        } else {
            if (validateWebsiteUrl(event.target.value) === null) {
                setImportUrlError(true);
            } else {
                setImportUrlError(false);
            }
        }
    }

    function onBlurImportUrl(event) {
        if (event.target.value.trim().length === 0) {
            setImportUrlError(false);

        } else {
            if (validateWebsiteUrl(event.target.value.trim()) === null) {
                setImportUrlError(true);
            } else {
                setImportUrlError(false);
            }
        }
        setImportUrl(event.target.value.trim());
    }




    function onChangeCompanyLinkedin(event) {
        setCompanyLinkedin(event.target.value);
        if (event.target.value.length === 0) {
            setCompanyLinkedinUrlError(false);
        } else {
            if (validateLinkedinUrl(event.target.value) === null) {
                setCompanyLinkedinUrlError(true);
            } else {
                setCompanyLinkedinUrlError(false);
            }
        }
    }

    function onBlurCompanyLinkedin(event) {
        if (event.target.value.trim().length === 0) {
            setCompanyLinkedinUrlError(false);
        }
        else {
            if (validateLinkedinUrl(event.target.value.trim()) === null) {
                setCompanyLinkedinUrlError(true);
            } else {
                setCompanyLinkedinUrlError(false);
            }
        }
        setCompanyLinkedin(event.target.value.trim());
    }

    function onChangeMediakit(e) {
        let count = 0;

        if (e.target.files.length > 0) {
            let tempMediaKit = [...mediakit];

            for (let file of e.target.files) {

                if (file.size / (1024 * 1024) < 100
                    // && (file.type === "application/vnd.ms-powerpoint" || file.type === "application/vnd.openxmlformats-officedocument.presentationml.presentation")
                ) {
                    tempMediaKit.push({
                        data: file,
                        preview: URL.createObjectURL(file),
                        filename: file.name,
                        size: file.size
                    });
                }
                else {
                    count++;

                }
            }
            setMediakit(tempMediaKit);
            const fileInput00 = document.getElementById("file000");
            fileInput00.value = "";

            if (count !== 0) {
                notifyfailure(`${count} files are rejected as they are failing validation (File should be Less than 100mb `)
            }

            //   } else {
            //     setMediakit({
            //       data: "",
            //       preview: "",
            //     });
            //     setMediakitFilename("");
            //     notifyfailure("File Size Should be less than 100 MB");
            //   }
        }
    }

    const fetchAndDownloadFilesMediaKit = async (ob) => {
        try {

            try {
                const response = await fetch(ob.url);

                if (!response.ok) {
                    throw new Error(`Failed to fetch ${ob?.url}: ${response.statusText}`);
                }

                const blob = await response.blob();
                const filename = `${ob.fileName}${ob.fileName.includes("." + ob?.ext) ? "" : `${"." + ob.ext}`}`;

                // Create a temporary link element
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = filename;

                // Append the link to the body
                document.body.appendChild(link);

                // Programmatically click the link to trigger the download
                link.click();

                // Remove the link from the document
                document.body.removeChild(link);
            } catch (error) {
                console.error("Error fetching file:", error);
            }

            notifysuccess("File downloaded successfully");

        } catch (error) {
            notifyfailure("Error while fetching the media kit.");
        }
    };

    function onChangeDefineYourself(event) {
        if (event.length === 0) {
            setDefineYourselfIsRequiredError(true)
        }
        else {
            setDefineYourselfIsRequiredError(false)
        }

        setDefineYourself(event)
    }

    function onChangeIsMcm(event) {
        setIsMcmIsRequiredError(false)
        setIsMcm(event.target.value);
    }

    function onChangeGamEmail(event) {
        setGamEmailIsRequiredError(false);
        setGamEmail(event.target.value);

        if (validateEmail(event.target.value) === null) {
            setGamEmailUrlError(true);
        } else {
            setGamEmailUrlError(false);
        }
    }

    function onBlurGamEmail(event) {
        if (event.target.value.trim().length === 0) {
            setGamEmailUrlError(false);
            setGamEmailIsRequiredError(true);
        }
        else {
            if (validateEmail(event.target.value.trim()) === null) {
                setGamEmailUrlError(true);
            } else {
                setGamEmailUrlError(false);
            }
        }
        setGamEmail(event.target.value.trim());
    }


    function onChangeGamNetworkId(event) {
        setGamNetworkIdIsRequiredError(false);
        setGamNetworkId(event.target.value);
    }

    function onBlurGamNetworkId(event) {
        if (event.target.value.trim().length === 0) {
            setGamNetworkIdIsRequiredError(true);
        }
        setGamNetworkId(event.target.value.trim());
    }



    function onChangeInventoryMonetize(event) {
        if (event.length === 0) {
            setInventoryMonetizeIsRequiredError(true)
        }
        else {
            setInventoryMonetizeIsRequiredError(false)
        }

        if (!event.includes("Others")) {
            setInventoryMonetizeOtherIsRequiredError(false);
        }

        setInventoryMonetize(event)
    }

    function onChangeInventoryMonetizeWebsiteUserSync(event) {
        setInventoryMonetizeWebsiteUserSyncIsRequiredError(false)
        setInventoryMonetizeWebsiteUserSync(event.target.value);
    }

    function onChangeInventoryMonetizeWebsiteBanner(event) {
        setInventoryMonetizeWebsiteBannerIsRequiredError(false)
        setInventoryMonetizeWebsiteBanner(event.target.value);
    }


    function onChangeAdFormatMonetize(event) {
        if (event.length === 0) {
            setAdFormatMonetizeIsRequiredError(true)
        }
        else {
            setAdFormatMonetizeIsRequiredError(false)
        }
        if (!event.includes("Others")) setAdFormatMonetizeOtherIsRequiredError(false);
        setAdFormatMonetize(event)
    }

    function onChangeIntegrationType(event) {
        if (event.length > 0) {
            setIntegrationTypeIsRequiredError(false)
        }
        else {
            setIntegrationTypeIsRequiredError(true)
        }
        setIntegrationType(event)
    }

    function onChangePrebidQuestion(event) {
        setPrebidQuestionIsRequiredError(false);
        setPrebidQuestion(event.target.value);
    }

    function onBlurPrebidQuestion(event) {
        if (event.target.value.trim().length === 0) {
            setPrebidQuestionIsRequiredError(true);
        }
        setPrebidQuestion(event.target.value.trim());
    }

    function onChangeOrtbType(event) {
        setOrtbType(event)
        if (event?.length === 0) {
            setOrtbTypeIsRequiredError(true)
        }
        else {
            setOrtbTypeIsRequiredError(false)
        }
    }

    function onChangeOrtbQuestion(event) {
        setOrtbQuestionIsRequiredError(false);
        setOrtbQuestion(event.target.value);
    }

    function onBlurOrtbQuestion(event) {
        if (event.target.value.trim().length === 0) {
            setOrtbQuestionIsRequiredError(true);
        }
        setOrtbQuestion(event.target.value.trim());
    }

    function onChangeVastType(event) {
        setVastType(event)
        if (event?.length === 0) {
            setVastTypeIsRequiredError(true)
        }
        else {
            setVastTypeIsRequiredError(false)
        }
    }


    function onChangeIntegrationProtocolPlayer(event) {
        setIntegrationProtocolPlayer(event.target.value);
    }

    function onBlurIntegrationProtocolPlayer(event) {
        setIntegrationProtocolPlayer(event.target.value.trim());
    }

    function onChangeIntegrationProtocolMime(event) {
        setIntegrationProtocolMimeIsRequiredError(false);
        setIntegrationProtocolMime(event.target.value);
    }

    function onBlurIntegrationProtocolMime(event) {
        if (event.target.value.trim().length === 0) {
            setIntegrationProtocolMimeIsRequiredError(true);
        }
        setIntegrationProtocolMime(event.target.value.trim());
    }


    function onChangeIntegrationProtocolTimeout(event) {
        setIntegrationProtocolTimeout(event.target.value);
    }

    function onBlurIntegrationProtocolTimeout(event) {
        setIntegrationProtocolTimeout(event.target.value.trim());
    }

    function onChangeIntegrationProtocolAdserver(event) {
        setIntegrationProtocolAdserver(event.target.value);
    }

    function onChangeIntegrationProtocolImpression(event) {
        setIntegrationProtocolImpression(event.target.value);
    }

    function onBlurIntegrationProtocolAdserver(event) {
        setIntegrationProtocolAdserver(event.target.value.trim());
    }

    function onChangeIntegrationProtocolBidrequest(event) {
        setIntegrationProtocolBidrequest(event.target.value);
    }

    function onChangeIntegrationProtocolUid(event) {
        setIntegrationProtocolUid(event.target.value);
    }

    function onBlurIntegrationProtocolBidrequest(event) {
        setIntegrationProtocolBidrequest(event.target.value.trim());
    }

    function onChangeIntegrationProtocolRichMedia(event) {
        setIntegrationProtocolRichMediaIsRequiredError(false)
        setIntegrationProtocolRichMedia(event.target.value);
    }

    function onChangeIntegrationProtocolRichMediaCreative(event) {
        setIntegrationProtocolRichMediaCreative(event)
    }


    function onChangeRegulationTool(event) {
        setRegulationToolIsRequiredError(false);
        setRegulationTool(event.target.value);
    }

    function onBlurRegulationTool(event) {
        if (event.target.value.trim().length === 0) {
            setRegulationToolIsRequiredError(true);
        }
        setRegulationTool(event.target.value.trim());
    }

    function onChangeRegulationAdserver(event) {
        setRegulationAdserverIsRequiredError(false);
        setRegulationAdserver(event.target.value);
    }

    function onBlurRegulationAdserver(event) {
        if (event.target.value.trim().length === 0) {
            setRegulationAdserverIsRequiredError(true);
        }
        setRegulationAdserver(event.target.value.trim());
    }

    function onChangeRegulationParameter(event) {
        if (event.length === 0) {
            setRegulationParameterIsRequiredError(true)
        }
        else {
            setRegulationParameterIsRequiredError(false)
        }
        if (!event.includes("Others")) setRegulationParameterOtherIsRequiredError(false);
        setRegulationParameter(event)
    }


    function onChangeSellerType(event) {
        setSellerTypeIsRequiredError(false)
        setSellerType(event.target.value);
    }

    function onChangeSellerName(event) {
        setSellerNameIsRequiredError(false);
        setSellerName(event.target.value);
    }

    function onBlurSellerName(event) {
        if (event.target.value.trim().length === 0) {
            setSellerNameIsRequiredError(true);
        }
        setSellerName(event.target.value.trim());
    }

    function onChangeSellerDomain(event) {
        setSellerDomain(event.target.value);

        if (event.target.value.length === 0) {
            setSellerDomainUrlError(false);
            setSellerDomainIsRequiredError(true);
        } else {
            setSellerDomainIsRequiredError(false);

            if (validateWebsiteUrl(event.target.value) === null) {
                setSellerDomainUrlError(true);
            } else {
                setSellerDomainUrlError(false);
            }
        }
    }

    function onBlurSellerDomain(event) {
        if (event.target.value.trim().length === 0) {
            setSellerDomainUrlError(false);
            setSellerDomainIsRequiredError(true);
        } else {
            if (validateWebsiteUrl(event.target.value.trim()) === null) {
                setSellerDomainUrlError(true);
            } else {
                setSellerDomainUrlError(false);
            }
        }
        setSellerDomain(event.target.value.trim());
    }

    function onChangeIsSellerPassThroughCheckbox(event) {
        setIsSellerPassThroughCheckbox(event.target.checked);
    }


    const scrollToItem = (ref, offset = 80) => {
        if (ref && ref.current) {
            ref.current.style.scrollMarginTop = `${offset}px`;
            ref.current.scrollIntoView({ behavior: "smooth", block: "start" });
            setTimeout(() => {
                ref.current.style.scrollMarginTop = '';
            }, 0);
        }
    };

    const basicDetailsRef = useRef(null)
    const importUrlRef = useRef(null)
    const defineYourselfRef = useRef(null)
    const mcmRef = useRef(null)
    const inventoryMonetizeRef = useRef(null)
    const adFormatMonetizeRef = useRef(null)
    const integrationTypeRef = useRef(null)
    const integrationProtocolDetailsRef = useRef(null)
    const regulationDetailsRef = useRef(null)
    const sellerDetailsRef = useRef(null)
    const sensitiveDetailsRef = useRef(null)

    const errorDetect = () => {

        if (name.trim() === "" || nameIsRequiredError || poc.trim() === "" || pocIsRequiredError || companyName.trim() === "" || companyNameIsRequiredError || companyWebsite.trim() === "" || companyWebsiteIsRequiredError || companyWebsiteUrlError || im.trim() === "" || imIsRequiredError || companyLinkedinUrlError) {
            scrollToItem(basicDetailsRef);
            return
        }

        if (importUrlError) {
            scrollToItem(importUrlRef);
            return
        }

        if (defineYourself.length === 0 || defineYourselfIsRequiredError) {
            scrollToItem(defineYourselfRef);
            return
        }


        if (isMcm === null || isMcmIsRequiredError ||
            (isMcm ? gamEmail.trim === "" : false) ||
            (isMcm ? gamNetworkId.trim === "" : false) ||
            (isMcm ? gamEmailIsRequiredError : false) ||
            (isMcm ? gamEmailUrlError : false) ||
            (isMcm ? gamNetworkIdIsRequiredError : false)

        ) {
            scrollToItem(mcmRef);
            return
        }

        if (inventoryMonetize.length === 0 || inventoryMonetizeIsRequiredError ||
            (inventoryMonetize.includes("Website") ? inventoryMonetizeWebsiteUserSync === null : false) ||
            (inventoryMonetize.includes("Website") ? inventoryMonetizeWebsiteBanner === null : false) ||
            (inventoryMonetize.includes("Others") ? inventoryMonetizeOther.trim() === "" : false)
        ) {
            scrollToItem(inventoryMonetizeRef);
            return
        }

        if (adFormatMonetize.length === 0 || adFormatMonetizeIsRequiredError ||
            (adFormatMonetize.includes("Others") ? adFormatMonetizeOther.trim() === "" : false)
        ) {
            scrollToItem(adFormatMonetizeRef);
            return
        }

        if (
            integrationType.length === 0 || integrationTypeIsRequiredError ||
            (integrationType.includes("Prebid") && (prebidQuestion.trim() === "" || prebidQuestionIsRequiredError)) ||
            (integrationType.includes("ORTB") && (ortbType.length === 0 || ortbTypeIsRequiredError || ortbQuestion.trim() === "" || ortbQuestionIsRequiredError)) ||
            (integrationType.includes("VAST") && (vastType.length === 0 || vastTypeIsRequiredError))

        ) {
            scrollToItem(integrationTypeRef);
            return
        }

        if (integrationProtocolMime === "" || integrationProtocolMimeIsRequiredError || integrationProtocolRichMedia === null || integrationProtocolRichMediaIsRequiredError) {
            scrollToItem(integrationProtocolDetailsRef);
            return
        }

        if (regulationToolIsRequiredError || regulationAdserverIsRequiredError || regulationParameterIsRequiredError ||
            (regulationParameter.includes("Others") ? regulationParameterOther.trim() === "" : false)
        ) {
            scrollToItem(regulationDetailsRef);
            return
        }

        if (props.callFrom === "listing" && (sellerType === "" || sellerTypeIsRequiredError || sellerNameIsRequiredError || sellerDomainIsRequiredError || sellerDomainUrlError)) {
            scrollToItem(sellerDetailsRef);
            return
        }

    }



    const handleSubmit = async (e) => {
        e.preventDefault();
        errorDetect()

        if (
            name !== "" &&
            poc !== "" &&
            companyName !== "" &&
            companyWebsite !== "" &&
            // email !== "" &&
            im !== "" &&
            defineYourself.length !== 0 &&
            isMcm !== null &&
            (isMcm ? gamEmail !== "" : true) &&
            (isMcm ? gamNetworkId !== "" : true) &&
            inventoryMonetize.length !== 0 &&
            (inventoryMonetize.includes("Website") ? inventoryMonetizeWebsiteUserSync !== null : true) &&
            (inventoryMonetize.includes("Website") ? inventoryMonetizeWebsiteBanner !== null : true) &&
            adFormatMonetize.length !== 0 &&
            integrationType.length !== 0 &&
            ((integrationType.includes("Prebid")) ? prebidQuestion !== "" : true) &&
            ((integrationType.includes("ORTB")) ? ortbQuestion !== "" : true) &&
            ((integrationType.includes("ORTB")) ? ortbType.length > 0 : true) &&
            ((integrationType.includes("VAST")) ? vastType.length > 0 : true) &&
            integrationProtocolMime !== "" &&
            integrationProtocolRichMedia !== null &&
            regulationTool !== "" &&
            regulationAdserver !== "" &&
            regulationParameter.length !== 0 &&
            (props.callFrom === "listing" ? sellerType !== "" && sellerName !== "" && sellerDomain !== "" : true)
        ) {

            // console.log("hit 1")
            if (
                nameIsRequiredError === false &&
                pocIsRequiredError === false &&
                companyNameIsRequiredError === false &&
                companyWebsiteUrlError === false &&
                companyWebsiteIsRequiredError === false &&
                // emailIsRequiredError === false &&
                // emailUrlError === false &&
                imIsRequiredError === false &&
                companyLinkedinUrlError === false &&
                importUrlError === false &&
                defineYourselfIsRequiredError === false &&
                (isMcm ? gamEmailIsRequiredError === false : true) &&
                (isMcm ? gamEmailUrlError === false : true) &&
                (isMcm ? gamNetworkIdIsRequiredError === false : true) &&
                inventoryMonetizeIsRequiredError === false &&
                (inventoryMonetize.includes("Website") ? inventoryMonetizeWebsiteUserSyncIsRequiredError === false : true) &&
                (inventoryMonetize.includes("Website") ? inventoryMonetizeWebsiteBannerIsRequiredError === false : true) &&
                (inventoryMonetize.includes("Others") ? inventoryMonetizeOtherIsRequiredError === false : true) &&
                adFormatMonetizeIsRequiredError === false &&
                (adFormatMonetize.includes("Others") ? adFormatMonetizeOtherIsRequiredError === false : true) &&
                integrationTypeIsRequiredError === false &&
                ((integrationType.includes("Prebid")) ? prebidQuestionIsRequiredError === false : true) &&
                ((integrationType.includes("ORTB")) ? ortbQuestionIsRequiredError === false : true) &&
                ((integrationType.includes("ORTB")) ? ortbTypeIsRequiredError === false : true) &&
                ((integrationType.includes("VAST")) ? vastTypeIsRequiredError === false : true) &&
                integrationProtocolMimeIsRequiredError === false &&
                integrationProtocolRichMediaIsRequiredError === false &&
                regulationToolIsRequiredError === false &&
                regulationAdserverIsRequiredError === false &&
                regulationParameterIsRequiredError === false &&
                (regulationParameter.includes("Others") ? regulationParameterOtherIsRequiredError === false : true) &&
                (props.callFrom === "listing" ? sellerTypeIsRequiredError === false && sellerNameIsRequiredError === false && sellerDomainIsRequiredError === false && sellerDomainUrlError === false : true)
            ) {

                // console.log("hit 2")


                let formData = new FormData();

                /* INVENTORY FILE UPLOAD VALIDATION - COMMENTED OUT
                // ❗ VALIDATION BLOCK

                if (props.callFrom === "listing") {
                    if (currentStatus === "new" || currentStatus === "onboard") {

                        if (inventoryMonetize.includes("CTV / FAST Apps")) {
                            if (!inventoryCtvData?.length || !inventoryCtvName) {
                                notifyfailure("Please upload CTV inventory file");
                                return;
                            }
                        }

                        if (inventoryMonetize.includes("Mobile App (Android / iOS)")) {
                            if (!inventoryMobileData?.length || !inventoryMobileName) {
                                notifyfailure("Please upload Mobile App inventory file");
                                return;
                            }
                        }


                        if (inventoryMonetize.includes("Website")) {
                            if (!inventoryWebsiteData?.length || !inventoryWebsiteName) {
                                notifyfailure("Please upload Website inventory file");
                                return;
                            }
                        }
                    }


                }
                else {

                    if (inventoryMonetize.includes("CTV / FAST Apps")) {
                        if (!inventoryCtvData?.length || !inventoryCtvName) {
                            notifyfailure("Please upload CTV inventory file");
                            return;
                        }
                    }

                    if (inventoryMonetize.includes("Mobile App (Android / iOS)")) {
                        if (!inventoryMobileData?.length || !inventoryMobileName) {
                            notifyfailure("Please upload Mobile App inventory file");
                            return;
                        }
                    }


                    if (inventoryMonetize.includes("Website")) {
                        if (!inventoryWebsiteData?.length || !inventoryWebsiteName) {
                            notifyfailure("Please upload Website inventory file");
                            return;
                        }
                    }

                }
                */






                formData.append("p_name", name);
                formData.append("poc", poc);
                formData.append("o_name", companyName);
                formData.append("c_website", companyWebsite);
                formData.append("email", email);
                formData.append("im", JSON.stringify({ "label": selectedIm, "value": im }));
                formData.append("country", country);
                formData.append("o_contact", companyLinkedin);

                formData.append("media_link", importUrl);



                formData.append("defineYourself", JSON.stringify(defineYourself));

                formData.append("isMcm", isMcm);
                formData.append("gamEmail", gamEmail);
                formData.append("gamNetworkCode", gamNetworkId);

                formData.append("inventory_type_select", JSON.stringify(inventoryMonetize));
                formData.append("inventory_type_select_other", inventoryMonetizeOther);
                formData.append("inventory_type_select_website_usersync", inventoryMonetizeWebsiteUserSync);
                formData.append("inventory_type_select_website_bannerPlacement", inventoryMonetizeWebsiteBanner);

                formData.append("ad_format_monetise", JSON.stringify(adFormatMonetize));
                formData.append("ad_format_monetise_other", JSON.stringify(adFormatMonetizeOther));

                formData.append("integration_type", JSON.stringify(integrationType))
                formData.append("prebidQuestion", prebidQuestion);
                formData.append("ortbQuestion", ortbQuestion);
                formData.append("ortb_type", JSON.stringify(ortbType))
                formData.append("vast_type", JSON.stringify(vastType))


                formData.append("integration_protocol_player", integrationProtocolPlayer);
                formData.append("integration_protocol_mime", integrationProtocolMime);
                formData.append("integration_protocol_timeout", integrationProtocolTimeout);
                formData.append("integration_protocol_adserver", integrationProtocolAdserver);
                formData.append("integration_protocol_impression", integrationProtocolImpression);
                formData.append("integration_protocol_bidrequest", integrationProtocolBidrequest);
                formData.append("integration_protocol_uid", integrationProtocolUid);
                formData.append("integration_protocol_rich_media", integrationProtocolRichMedia);
                formData.append("integration_protocol_rich_media_creative", JSON.stringify(integrationProtocolRichMediaCreative));

                formData.append("regulation_brand_safety_tool", regulationTool);
                formData.append("regulation_brand_safety_adserver", regulationAdserver);
                formData.append("regulation_brand_safety_regulator", JSON.stringify(regulationParameter));
                formData.append("regulation_brand_safety_regulator_other", regulationParameterOther);

                const checkedIds = Object.entries(sensitive)
                    .filter(([, v]) => v.isChecked)
                    .map(([id]) => id);
                setSensitiveAttemptedIds(new Set(checkedIds));
                const hasSensitiveValidationError = checkedIds.some(id => !sensitive[id]?.selection);
                if (hasSensitiveValidationError) {
                    notifyfailure("Please select custom requirements for the checked sensitive categories.");
                    scrollToItem(sensitiveDetailsRef)
                    return;
                }

                formData.append('blockCategory', JSON.stringify([...selected]));
                const filteredSensitive = Object.fromEntries(
                    Object.entries(sensitive).filter(([, v]) => v.isChecked)
                );
                formData.append('bcate_data', JSON.stringify(filteredSensitive));

                if (props.callFrom === "listing") {
                    formData.append("s_type", sellerType);
                    formData.append("s_name", sellerName);
                    formData.append("s_domain", sellerDomain);
                    formData.append("isSellerPassThrough_checkbox", isSellerPassThroughCheckbox)
                }

                // formData.append("inventoryWebsiteData", inventoryMonetize.includes("Website") ? JSON.stringify(inventoryWebsiteData) : []);
                // formData.append("inventoryWebsiteName", inventoryMonetize.includes("Website") ? inventoryWebsiteName : "");
                // formData.append("inventoryMobileData", inventoryMonetize.includes("Mobile App (Android / iOS)") ? JSON.stringify(inventoryMobileData) : []);
                // formData.append("inventoryMobileName", inventoryMonetize.includes("Mobile App (Android / iOS)") ? inventoryMobileName : "");
                // formData.append("inventoryCtvData", inventoryMonetize.includes("CTV / FAST Apps") ? JSON.stringify(inventoryCtvData) : []);
                // formData.append("inventoryCtvName", inventoryMonetize.includes("CTV / FAST Apps") ? inventoryCtvName : "");

                mediakit.forEach((file) => {
                    formData.append('mediaKit_new', file.data);
                });

                formData.append("mediaKit", JSON.stringify(mediakit2));

                if (props.callFrom === "register" || props.callFrom === "listing") {

                    setButtonValue(true);

                    const pubID = props.signupData?._id ?? props.id ?? "";
                    axios
                        .put(`${configData.SERVER_URL}ops/editPub?pubId=${pubID}`, formData, {
                            headers: {
                                "Content-Type": "multipart/form-data",
                            }
                        }
                        )
                        .then((response) => {

                            notifysuccess(response.data.message);
                            if (props.callFrom === "listing") {
                                setTimeout(() => {
                                    props.handlePageViewChange("table", "yes")
                                }, 1500)
                            }
                            else {
                                setTimeout(() => {
                                    window.location.reload()
                                }, 1500)
                            }


                        })
                        .catch((error) => {
                            if (error?.response) {
                                if (error.response.data.message?.length !== 0) {
                                    notifyfailure(error.response.data.message);
                                }
                            } else {
                                notifycatch();
                            }
                            setButtonValue(false);
                        });

                }
                else if (props.callFrom === "onboarding" || props.callFrom === "profile") {

                    let status = Cookies.get("token_xapads_ssp") ? true : false;
                    if (status) {

                        setButtonValue(true);
                        let token = Cookies.get("token_xapads_ssp");
                        // let id = jwtDecode(token)._id;

                        axios
                            .put(`${configData.SERVER_URL}ops/editPub`, formData, {
                                headers: {
                                    "Content-Type": "multipart/form-data",
                                    "x-access-token": token,
                                }
                            }
                            )
                            .then((response) => {

                                notifysuccess(response.data.message);
                                setTimeout(() => {
                                    window.location.reload()
                                }, 1500)
                                // if (props.signupData !== null) {
                                //     setTimeout(() => {
                                //         window.location.replace('/login')
                                //     }, 1500)
                                // }
                                // else {
                                //     setTimeout(() => {
                                //         window.location.reload()
                                //     }, 1500)
                                // }


                            })
                            .catch((error) => {
                                if (error?.response) {
                                    if (error.response.data.message?.length !== 0) {
                                        notifyfailure(error.response.data.message);
                                    }
                                } else {
                                    notifycatch();
                                }
                                setButtonValue(false);
                            });

                    }




                }
            }
        } else {
            if (name === "") {
                setNameIsRequiredError(true);
            }
            if (poc === "") {
                setPocIsRequiredError(true);
            }
            if (companyName === "") {
                setCompanyNameIsRequiredError(true);
            }
            if (companyWebsite === "") {
                setCompanyWebsiteIsRequiredError(true);
            }
            // if (email === "") {
            //     setEmailIsRequiredError(true);
            // }
            if (im === "") {
                setImIsRequiredError(true);
            }
            // if (country === "") {
            //     setCountryIsRequiredError(true);
            // }
            if (defineYourself.length === 0) {
                setDefineYourselfIsRequiredError(true);
            }
            if (isMcm === null) {
                setIsMcmIsRequiredError(true);
            }
            if (isMcm && gamEmail === "") {
                setGamEmailIsRequiredError(true);
            }
            if (isMcm && gamNetworkId === "") {
                setGamNetworkIdIsRequiredError(true);
            }
            if (inventoryMonetize.length === 0) {
                setInventoryMonetizeIsRequiredError(true);
            }

            if (inventoryMonetize.includes("Website") && inventoryMonetizeWebsiteUserSync === null) {
                setInventoryMonetizeWebsiteUserSyncIsRequiredError(true);
            }

            if (inventoryMonetize.includes("Website") && inventoryMonetizeWebsiteBanner === null) {
                setInventoryMonetizeWebsiteBannerIsRequiredError(true);
            }

            if (inventoryMonetize.includes("Others") && inventoryMonetizeOther.trim() === "") {
                setInventoryMonetizeOtherIsRequiredError(true);
            }

            if (adFormatMonetize.length === 0) {
                setAdFormatMonetizeIsRequiredError(true);
            }

            if (adFormatMonetize.includes("Others") && adFormatMonetizeOther.trim() === "") {
                setAdFormatMonetizeOtherIsRequiredError(true);
            }

            if (integrationType.length === 0) {
                setIntegrationTypeIsRequiredError(true)
            }

            if (integrationType.includes("Prebid") && prebidQuestion === "") {
                setPrebidQuestionIsRequiredError(true)
            }

            if (integrationType.includes("ORTB") && ortbQuestion === "") {
                setOrtbQuestionIsRequiredError(true)
            }

            if (integrationType.includes("ORTB") && ortbType.length === 0) {
                setOrtbTypeIsRequiredError(true)
            }

            if (integrationType.includes("VAST") && vastType.length === 0) {
                setVastTypeIsRequiredError(true)
            }

            if (integrationProtocolMime === "") {
                setIntegrationProtocolMimeIsRequiredError(true);
            }

            if (integrationProtocolRichMedia === null) {
                setIntegrationProtocolRichMediaIsRequiredError(true);
            }

            if (regulationTool === "") {
                setRegulationToolIsRequiredError(true);
            }
            if (regulationAdserver === "") {
                setRegulationAdserverIsRequiredError(true);
            }
            if (regulationParameter.length === 0) {
                setRegulationParameterIsRequiredError(true);
            }

            if (regulationParameter.includes("Others") && regulationParameterOther.trim() === "") {
                setRegulationParameterOtherIsRequiredError(true);
            }
            if (props.callFrom === "listing") {
                if (sellerType === "") {
                    setSellerTypeIsRequiredError(true);
                }
                if (sellerName === "") {
                    setSellerNameIsRequiredError(true);
                }
                if (sellerDomain === "") {
                    setSellerDomainIsRequiredError(true);
                }
            }
        }
    };





    const handleDownload = async (type) => {
        // let status = Cookies.get("token_xapads_ssp") ? true : false;
        // if (status) {
        //     let token = Cookies.get("token_xapads_ssp");
        axios
            .get(
                configData.SERVER_URL +
                `user/downloadSample?type=` + type,
                {
                    headers: {
                        "Content-Type": "application/json",
                        // "x-access-token": token,
                    },
                    responseType: "blob",
                }
            )
            .then((response) => {
                const blob = new Blob([response.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });
                saveAs(blob, type + "_" + new Date().getTime() + ".xlsx");
            })
            .catch((error) => { });

    };









    //---------------------------------------------------------------main code ends here ---------------------------------------------------

    return (
        <div className={props.callFrom === "register" ? "container_box--wrapper" : "container_box--wrapper pt_header"} style={{ paddingTop: props.callFrom === "register" ? '3rem' : '' }} >
            {props.callFrom === "listing" &&
                <div className="container_box--breadcrumb">
                    <ul className='container_box--breadcrumb-list'>
                        <li><Link onClick={() => {
                            props.handlePageViewChange("table", "no")
                        }} ><img src={publishersIcon} alt='USP' /> Publishers</Link></li>
                        <li className='primary'>View</li>
                    </ul>
                </div>
            }

            {!((currentStatus === "onboard" || currentStatus === "rejected") && isDisabled && props.callFrom === "onboarding") &&
                <div className="container_box--wrapper--title d_flex justify-content-between align-items-center">
                    {props.callFrom === "listing" ?
                        <div className="back_btn_d2">
                            <img src={backButton} className="img-fluid" alt=""
                                onClick={() => {
                                    props.handlePageViewChange("table", "no")
                                }}
                            />
                            <h1 className="heading">
                                {props.publisherViewName}
                            </h1>
                        </div> :
                        <div className="back_btn_d2">
                            <h1 className="onboarding_heading"> {props.callFrom === "profile" ? "My Profile" : "To know your company better"} </h1>
                        </div>
                    }
                </div>
            }
            <div className={isDisabled ? "container_box--content pt_20 " : "container_box--content pt_20 form_scrollable_div_d2"}>
                {currentStatus === "onboard" && isDisabled && props.callFrom === "onboarding" &&
                    <div className="container_box--width w-100">
                        <Row>
                            <Col span={24}>
                                <div className='profile_review_alert_div'>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
                                        <path d="M18 5.625C15.33 5.625 12.7199 6.41676 10.4998 7.90016C8.27975 9.38356 6.54942 11.492 5.52763 13.9588C4.50585 16.4256 4.2385 19.14 4.7594 21.7587C5.28031 24.3775 6.56606 26.7829 8.45406 28.6709C10.3421 30.559 12.7475 31.8447 15.3663 32.3656C17.985 32.8865 20.6994 32.6192 23.1662 31.5974C25.633 30.5756 27.7414 28.8453 29.2248 26.6252C30.7082 24.4051 31.5 21.795 31.5 19.125C31.4959 15.5458 30.0723 12.1144 27.5414 9.58358C25.0106 7.05273 21.5792 5.62909 18 5.625ZM18 30.375C15.775 30.375 13.5999 29.7152 11.7498 28.479C9.89979 27.2429 8.45785 25.4859 7.60636 23.4302C6.75488 21.3745 6.53209 19.1125 6.96617 16.9302C7.40026 14.7479 8.47171 12.7434 10.0451 11.17C11.6184 9.59671 13.623 8.52525 15.8052 8.09117C17.9875 7.65708 20.2495 7.87987 22.3052 8.73136C24.3609 9.58284 26.1179 11.0248 27.354 12.8748C28.5902 14.7249 29.25 16.9 29.25 19.125C29.2467 22.1077 28.0603 24.9672 25.9513 27.0763C23.8422 29.1853 20.9827 30.3717 18 30.375ZM24.4209 12.7041C24.5255 12.8085 24.6085 12.9326 24.6651 13.0692C24.7218 13.2058 24.7509 13.3522 24.7509 13.5C24.7509 13.6478 24.7218 13.7942 24.6651 13.9308C24.6085 14.0674 24.5255 14.1915 24.4209 14.2959L18.7959 19.9209C18.6914 20.0255 18.5673 20.1084 18.4308 20.1649C18.2942 20.2215 18.1478 20.2506 18 20.2506C17.8522 20.2506 17.7058 20.2215 17.5692 20.1649C17.4327 20.1084 17.3086 20.0255 17.2041 19.9209C17.0995 19.8164 17.0166 19.6923 16.9601 19.5558C16.9035 19.4192 16.8744 19.2728 16.8744 19.125C16.8744 18.9772 16.9035 18.8308 16.9601 18.6942C17.0166 18.5577 17.0995 18.4336 17.2041 18.3291L22.8291 12.7041C22.9335 12.5995 23.0576 12.5165 23.1942 12.4599C23.3308 12.4033 23.4772 12.3741 23.625 12.3741C23.7728 12.3741 23.9192 12.4033 24.0558 12.4599C24.1924 12.5165 24.3165 12.5995 24.4209 12.7041ZM13.5 2.25C13.5 1.95163 13.6185 1.66548 13.8295 1.4545C14.0405 1.24353 14.3266 1.125 14.625 1.125H21.375C21.6734 1.125 21.9595 1.24353 22.1705 1.4545C22.3815 1.66548 22.5 1.95163 22.5 2.25C22.5 2.54837 22.3815 2.83452 22.1705 3.0455C21.9595 3.25647 21.6734 3.375 21.375 3.375H14.625C14.3266 3.375 14.0405 3.25647 13.8295 3.0455C13.6185 2.83452 13.5 2.54837 13.5 2.25Z" fill="#FA8E02" />
                                    </svg>
                                    <div>
                                        <h3>Profile under review!</h3>
                                        <p>Sit back and Relax your profile is currently under review by our team. We will notify you via email upon successful completion.</p>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                }
                {currentStatus === "rejected" && isDisabled && props.callFrom === "onboarding" &&
                    <div className="container_box--width w-100">
                        <Row>
                            <Col span={24}>
                                <div className='profile_review_alert_div --rejected'>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
                                        <path d="M18 33C26.2843 33 33 26.2843 33 18C33 9.71573 26.2843 3 18 3C9.71573 3 3 9.71573 3 18C3 26.2843 9.71573 33 18 33Z" stroke="#D92D20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M22.5 13.5L13.5 22.5" stroke="#D92D20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M13.5 13.5L22.5 22.5" stroke="#D92D20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                    <div>
                                        <h3>Your account is rejected</h3>
                                        <p>Thank you for your interest. We regret to inform you that your account registration has been rejected after a review of your submitted information. Unfortunately, it does not meet the required criteria at this time.</p>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                }
                <div className="container_box--width">
                    <Row gutter={16}>
                        <Col span={8}>
                            <div className="container_box--label-info">
                                <label>Basic details</label>
                            </div>
                        </Col>

                        <Col span={16}>
                            <div className="container_box--form-container" ref={basicDetailsRef}>
                                <Row gutter={16}>
                                    <Col span={12}>
                                        <div className="form_content_block--group">
                                            <label className="form_label">Publisher Name *</label>
                                            <Input
                                                className={
                                                    nameIsRequiredError
                                                        ? "form_control basic error"
                                                        : "form_control basic"
                                                }
                                                value={name}
                                                onBlur={onBlurName}
                                                onChange={onChangeName}
                                                autocomplete="off"
                                                disabled={isDisabled}


                                            />
                                            <span className='error_content'>
                                                {nameIsRequiredError && (
                                                    <> This field is required</>
                                                )}
                                            </span>
                                        </div>
                                    </Col>
                                    <Col span={12}>
                                        <div className="form_content_block--group">
                                            <label className="form_label">Full name of primary POC *</label>
                                            <Input
                                                className={
                                                    pocIsRequiredError
                                                        ? "form_control basic error"
                                                        : "form_control basic"
                                                }
                                                value={poc}
                                                onBlur={onBlurPoc}
                                                onChange={onChangePoc}
                                                autocomplete="off"
                                                disabled={isDisabled}


                                            />
                                            <span className='error_content'>
                                                {pocIsRequiredError && (
                                                    <> This field is required</>
                                                )}
                                            </span>
                                        </div>
                                    </Col>
                                    <Col span={12}>
                                        <div className="form_content_block--group">
                                            <label className="form_label">Organisation Name *</label>
                                            <Input
                                                className={
                                                    companyNameIsRequiredError
                                                        ? "form_control basic error"
                                                        : "form_control basic"
                                                }
                                                value={companyName}
                                                onBlur={onBlurCompanyName}
                                                onChange={onChangeCompanyName}
                                                autocomplete="off"
                                                disabled={isDisabled}

                                            />
                                            <span className='error_content'>
                                                {companyNameIsRequiredError && (
                                                    <> This field is required</>
                                                )}
                                            </span>
                                        </div>
                                    </Col>

                                    <Col span={12}>
                                        <div className="form_content_block--group">
                                            <label className="form_label">Company website *</label>
                                            <Input
                                                className={
                                                    (companyWebsiteIsRequiredError || companyWebsiteUrlError)
                                                        ? "form_control basic error"
                                                        : "form_control basic"
                                                }
                                                value={companyWebsite}
                                                onBlur={onBlurCompanyWebsite}
                                                onChange={onChangeCompanyWebsite}
                                                autocomplete="off"
                                                disabled={isDisabled}

                                            />
                                            <span className='error_content'>
                                                {companyWebsiteIsRequiredError && (
                                                    <> This field is required</>
                                                )}
                                                {companyWebsiteUrlError && (
                                                    <> Invalid Website Url</>
                                                )}
                                            </span>
                                        </div>
                                    </Col>
                                    <Col span={12}>
                                        <div className="form_content_block--group">
                                            <label className="form_label">Email Address *</label>
                                            <Input
                                                className="form_control basic"
                                                value={email}
                                                disabled

                                            />
                                            <span className="error_content"> </span>
                                        </div>
                                    </Col>
                                    <Col span={12}>
                                        <div className="form_content_block--group">
                                            <label className="form_label">IM * </label>
                                            <Space.Compact className='form_compact'>
                                                <Select
                                                    className='form_select'
                                                    value={selectedIm}
                                                    onChange={onChangeSelectedIm}
                                                    options={constantData.IM_OPTIONS}
                                                    disabled={isDisabled}

                                                />
                                                <Input
                                                    className={imIsRequiredError
                                                        ? "form_control basic error"
                                                        : "form_control basic"
                                                    }
                                                    value={im}
                                                    onChange={onChangeIm}
                                                    onBlur={onBlurIm}
                                                    autocomplete="off"
                                                    disabled={isDisabled}

                                                />
                                            </Space.Compact>
                                            <span className="error_content">
                                                {imIsRequiredError && (
                                                    <> This field is required</>
                                                )}

                                            </span>
                                        </div>
                                    </Col>


                                    <Col span={12}>
                                        <div className="form_content_block--group mb-0">
                                            <label className="form_label">Headquarter Country</label>
                                            <Select
                                                showSearch
                                                // open={true}
                                                placeholder='Select'
                                                optionFilterProp="label"
                                                className="form_select basic showing_placeholder_text"
                                                value={country || undefined}
                                                onChange={(event) => {
                                                    setCountryIsRequiredError(false)
                                                    setCountry(event);
                                                }}
                                                options={countryOptions}
                                                disabled={isDisabled}

                                            // onSearch={(value) => {
                                            //     console.log('search:', value);
                                            //   }}
                                            />
                                            <span className="error_content"></span>
                                        </div>
                                    </Col>
                                    <Col span={12}>
                                        <div className="form_content_block--group mb-0">
                                            <label className="form_label">LinkedIn </label>
                                            <Input
                                                className={companyLinkedinUrlError
                                                    ? "form_control basic error"
                                                    : "form_control basic"
                                                }
                                                placeholder='https://'
                                                value={companyLinkedin}
                                                onBlur={onBlurCompanyLinkedin}
                                                onChange={onChangeCompanyLinkedin}
                                                autocomplete="off"
                                                disabled={isDisabled}

                                            />
                                            <span className="error_content">
                                                {companyLinkedinUrlError && (
                                                    <> Invalid LinkedIn Url</>
                                                )}
                                            </span>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col span={8}>
                            <div className="container_box--label-info">
                                <label>Media Kit</label>
                            </div>
                        </Col>

                        <Col span={16}>
                            <div className="container_box--form-container  "
                                ref={importUrlRef}
                                style={{
                                    paddingBottom:
                                        ((mediakit?.length ?? 0) + (mediakit2?.length ?? 0)) === 0 ||
                                            ((mediakit?.length ?? 0) + (mediakit2?.length ?? 0)) === 1
                                            ? "0px"
                                            : undefined
                                }}


                            >


                                {(mediakit?.length + mediakit2?.length) === 0 &&
                                    <Row gutter={16}

                                    >
                                        <>
                                            <Col span={11} className='file_uploaded_view_cls '>

                                                <div className={(mediakit?.length + mediakit2?.length) === 0 ? "form_content_block--group mb-0" : "form_content_block--group mb-3"}>
                                                    <label for='file000' className='ant_upload_drag --updated_design_cls'>
                                                        <div className='d-flex align-items-center justify-content-start' style={{ gap: '1.2rem' }}>
                                                            <p className="upload_drag_icon mx-0">
                                                                <img src={uploadIcon} alt='USP' />
                                                            </p>
                                                            <div className='text-start'>
                                                                <p className="ant_upload_text mt-0"><b className="primary">Click to upload</b> </p>
                                                                <p className="text-start ant_upload_hint">
                                                                    (max. 100 MB)
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </label>
                                                    <input className='form_upload d-none' type="file"
                                                        name="file000"
                                                        id="file000"
                                                        // accept=".ppt, .pptx"
                                                        multiple
                                                        onChange={onChangeMediakit}
                                                        disabled={isDisabled}
                                                    />

                                                </div>

                                            </Col>
                                            <Col span={1} className="or-col">
                                                <div className="or-divider">
                                                    <span>or</span>
                                                </div>
                                            </Col>
                                            <Col span={12}>
                                                <div className="form_content_block--group">
                                                    <label className="form_label">Import from URL</label>
                                                    <Input
                                                        className={importUrlError ? "form_control basic error" : "form_control basic"}
                                                        placeholder='Paste your media kit URL'
                                                        value={importUrl}
                                                        onChange={onChangeImportUrl}
                                                        onBlur={onBlurImportUrl}
                                                        disabled={isDisabled}
                                                    />
                                                    <span className="error_content">
                                                        {importUrlError && (
                                                            <> Invalid Url</>
                                                        )}
                                                    </span>
                                                </div>
                                            </Col>

                                        </>
                                    </Row>
                                }

                                {(mediakit?.length + mediakit2?.length) !== 0 &&
                                    <Row gutter={16} >
                                        <Col span={11} className='file_uploaded_view_cls'>


                                            <div className='new_file_upload_design_cls'
                                                style={{ paddingBottom: "0px" }}
                                            >

                                                <div className='d-flex align-items-start justify-content-between'>
                                                    <div style={{ width: "80%" }}>

                                                        {mediakit.map((media, index) => (
                                                            <div className="ant_upload_list--content border-0 padding-0">
                                                                <div className='d-flex align-items-start justify-content-between w-100'>
                                                                    <div className='d-flex align-items-center'
                                                                        style={{ width: "160px" }}
                                                                    >
                                                                        <img src={FileIcon} alt="USP" />
                                                                        <div className="ant_upload_list--info">

                                                                            <span className="ant_upload_list--info-name new_design_name ellipsis-2_text">
                                                                                {/* {media?.filename
                                                                                    ? media.filename.length > 16
                                                                                        ? <Tooltip title={media.filename}>
                                                                                            <span>{media.filename.slice(0, 16)}..</span>
                                                                                        </Tooltip>
                                                                                        : media.filename
                                                                                    : ""} */}
                                                                                <Tooltip title={media.filename}>
                                                                                    {media.filename}
                                                                                </Tooltip>
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                    <div className='d-flex'>

                                                                        <button type="link" className="ant_upload_list--delete"
                                                                            onClick={() => {
                                                                                let tempMediaKit = [...mediakit];
                                                                                tempMediaKit.splice(index, 1);
                                                                                setMediakit(tempMediaKit);
                                                                            }}
                                                                            disabled={isDisabled}
                                                                        >
                                                                            <Tooltip title="Delete">
                                                                                <img src={deleteIcon} alt="USP" />
                                                                            </Tooltip>
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}

                                                        {mediakit2?.map((media, index) => (
                                                            <div className="ant_upload_list--content border-0 padding-0">
                                                                <div className='d-flex align-items-start justify-content-between  w-100'>
                                                                    <div className='d-flex align-items-center'
                                                                        style={{ width: "160px" }}
                                                                    >
                                                                        <img src={FileIcon} alt="USP" />
                                                                        <div className="ant_upload_list--info">

                                                                            <span className="ant_upload_list--info-name new_design_name ellipsis-2_text">
                                                                                {/* {media?.fileName
                                                                                    ? media.fileName.length > 16
                                                                                        ? <Tooltip title={media.fileName}>
                                                                                            <span>{media.fileName.slice(0, 16)}..</span>
                                                                                        </Tooltip>
                                                                                        : media.fileName
                                                                                    : ""} */}
                                                                                <Tooltip title={media.fileName}>
                                                                                    {media.fileName}
                                                                                </Tooltip>
                                                                            </span>

                                                                        </div>
                                                                    </div>
                                                                    <div className='d-flex'>

                                                                        {media.hasOwnProperty('url') &&
                                                                            <button type="link" className="ant_upload_list--delete"
                                                                                onClick={() => {
                                                                                    fetchAndDownloadFilesMediaKit(
                                                                                        media

                                                                                    )

                                                                                }}
                                                                            >
                                                                                <Tooltip title="Download">
                                                                                    <img src={DownloadOrangeIcon} alt="USP" />
                                                                                </Tooltip>
                                                                            </button>
                                                                        }
                                                                        <button type="link" className="ant_upload_list--delete"
                                                                            onClick={() => {
                                                                                let tempMediaKit = [...mediakit2];
                                                                                tempMediaKit.splice(index, 1);
                                                                                setMediakit2(tempMediaKit);
                                                                            }}
                                                                            disabled={isDisabled}

                                                                        >
                                                                            <Tooltip title="Delete">
                                                                                <img src={deleteIcon} alt="USP" />
                                                                            </Tooltip>
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>

                                                    {/* <hr className='divider_line' /> */}
                                                    <Tooltip title="Upload More">
                                                        <button type="button" className="upload_btn">

                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                                <path d="M10.3637 10.3645L7.99924 8L5.63477 10.3645" stroke="#7434DB" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                <path d="M8 8V13.3201" stroke="#7434DB" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                <path d="M12.9591 11.7773C13.5356 11.4629 13.9911 10.9656 14.2536 10.3637C14.516 9.76176 14.5706 9.08958 14.4086 8.45321C14.2467 7.81685 13.8774 7.25255 13.3591 6.84937C12.8408 6.44618 12.203 6.22709 11.5463 6.22665H10.8015C10.6226 5.5346 10.2891 4.89211 9.82612 4.34748C9.36315 3.80286 8.78274 3.37028 8.12852 3.08226C7.4743 2.79425 6.7633 2.65828 6.04897 2.6846C5.33465 2.71092 4.63558 2.89884 4.00433 3.23422C3.37308 3.5696 2.82607 4.04371 2.40444 4.62093C1.9828 5.19814 1.6975 5.86343 1.56999 6.56678C1.44248 7.27013 1.47607 7.99323 1.66825 8.68172C1.86043 9.37022 2.20619 10.0062 2.67953 10.5418" stroke="#7434DB" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                <path d="M10.3637 10.3645L7.99924 8L5.63477 10.3645" stroke="#7434DB" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                            </svg>

                                                            <input className='upload_btn' type="file"
                                                                name="file000"
                                                                id="file000"
                                                                // accept=".ppt, .pptx"
                                                                multiple
                                                                onChange={onChangeMediakit}
                                                                disabled={isDisabled}
                                                            />
                                                            {/* Upload more */}
                                                        </button>
                                                    </Tooltip>

                                                </div>
                                            </div>


                                        </Col>
                                        <Col span={1} className={((mediakit?.length ?? 0) + (mediakit2?.length ?? 0)) === 1 ? "or-col" : "or-col2"}>
                                            <div className="or-divider">
                                                <span>or</span>
                                            </div>
                                        </Col>
                                        <Col span={12}>
                                            <div className="form_content_block--group">
                                                <label className="form_label">Import from URL</label>
                                                <Input
                                                    className={importUrlError ? "form_control basic error" : "form_control basic"}
                                                    placeholder='Paste your media kit URL'
                                                    value={importUrl}
                                                    onChange={onChangeImportUrl}
                                                    onBlur={onBlurImportUrl}
                                                    disabled={isDisabled}
                                                />
                                                <span className="error_content">
                                                    {importUrlError && (
                                                        <> Invalid Url</>
                                                    )}
                                                </span>
                                            </div>
                                        </Col>

                                    </Row>
                                }



                            </div>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col span={8}>
                            <div className="container_box--label-info">
                                <label>Define Yourself *</label>
                            </div>
                        </Col>

                        <Col span={16}>
                            <div className="container_box--form-container" ref={defineYourselfRef}>
                                <Row gutter={16}>
                                    <Col span={24}>
                                        <div className="form_content_block--group m-0">
                                            <div className=''>
                                                <Checkbox.Group className="form_checkbox equal_space"
                                                    value={defineYourself} onChange={onChangeDefineYourself}
                                                    disabled={isDisabled}

                                                >
                                                    <Checkbox className="checkbox_btn --flex_grow_cls integration_checkbox_width"
                                                        value="Direct Publisher">
                                                        Direct Publisher
                                                    </Checkbox>
                                                    <Checkbox className="checkbox_btn --flex_grow_cls integration_checkbox_width" value="Aggregator / Reseller">
                                                        Aggregator / Reseller
                                                    </Checkbox>
                                                    <Checkbox className="checkbox_btn --flex_grow_cls integration_checkbox_width" value="Network with owned & operated apps/sites">
                                                        Network with owned & operated apps/sites
                                                    </Checkbox>
                                                </Checkbox.Group>
                                                <span className="error_content">
                                                    {defineYourselfIsRequiredError && (
                                                        <> This field is required</>
                                                    )}
                                                </span>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col span={8}>
                            <div className="container_box--label-info">
                                <label>Do you accept MCM (Multiple Customer Management) invitation? *</label>
                            </div>
                        </Col>

                        <Col span={16}>
                            <div className="container_box--form-container" ref={mcmRef}>
                                <Row gutter={16}>
                                    <Col span={24}>
                                        <div className={isMcm ? "form_content_block--group" : "form_content_block--group mb-0"}>
                                            <div className=''>
                                                <Radio.Group className="form_radio equal_space"
                                                    onChange={onChangeIsMcm} value={isMcm}
                                                    disabled={isDisabled}

                                                >
                                                    <Radio className='radio_btn w-auto' value={true} onChange={onChangeIsMcm}>Yes</Radio>
                                                    <Radio className='radio_btn w-auto' value={false} onChange={onChangeIsMcm}>No</Radio>
                                                </Radio.Group>
                                                <span className="error_content">
                                                    {isMcmIsRequiredError && (
                                                        <> This field is required</>
                                                    )}
                                                </span>
                                            </div>
                                        </div>
                                    </Col>
                                    {isMcm && <>
                                        <Col span={12}>
                                            <div className="form_content_block--group mb-0">
                                                <label className="form_label">Google Ad Manager Email ID *</label>
                                                <Input
                                                    className={(gamEmailIsRequiredError || gamEmailUrlError) ? 'form_control basic error' : 'form_control basic'}
                                                    autoComplete="off"
                                                    placeholder="example@gmail.com"
                                                    value={gamEmail}
                                                    onBlur={onBlurGamEmail}
                                                    onChange={onChangeGamEmail}
                                                    disabled={isDisabled}

                                                />
                                                {gamEmailIsRequiredError && (
                                                    <span className="error_content">This field is required</span>
                                                )}

                                                {gamEmailUrlError && (
                                                    <span className="error_content">Invalid Email Address</span>
                                                )}
                                            </div>
                                        </Col>
                                        <Col span={12}>
                                            <div className="form_content_block--group mb-0">
                                                <label className="form_label">GAM Network Code *</label>
                                                <Input
                                                    className={
                                                        gamNetworkIdIsRequiredError
                                                            ? "form_control basic error"
                                                            : "form_control basic"
                                                    }
                                                    value={gamNetworkId}
                                                    onBlur={onBlurGamNetworkId}
                                                    onChange={onChangeGamNetworkId}
                                                    autocomplete="off"
                                                    disabled={isDisabled}

                                                />
                                                {gamNetworkIdIsRequiredError && (
                                                    <span className="error_content">This field is required</span>
                                                )}
                                            </div>
                                        </Col>
                                    </>}

                                </Row>
                            </div>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col span={8}>
                            <div className="container_box--label-info">
                                <label>What kind of inventory do you want to monetize with us? *</label>
                            </div>
                        </Col>

                        <Col span={16}>
                            <div className="container_box--form-container" ref={inventoryMonetizeRef}>
                                <Row gutter={16}>
                                    <Col span={24}>
                                        <div className="form_content_block--group mb-0">
                                            <div className=''>
                                                <Checkbox.Group className="form_checkbox equal_space"
                                                    value={inventoryMonetize}
                                                    onChange={onChangeInventoryMonetize}
                                                    disabled={isDisabled}
                                                >
                                                    <Checkbox className="checkbox_btn --flex_grow_cls integration_checkbox_width"
                                                        value="CTV / FAST Apps">
                                                        CTV / FAST Apps
                                                    </Checkbox>
                                                    <Checkbox className="checkbox_btn --flex_grow_cls integration_checkbox_width" value="Mobile App (Android / iOS)">
                                                        Mobile App (Android / iOS)
                                                    </Checkbox>
                                                    <Checkbox className="checkbox_btn --flex_grow_cls integration_checkbox_width" value="Website">
                                                        Website
                                                    </Checkbox>
                                                    <Checkbox className={inventoryMonetize.includes("Others") ? "checkbox_btn w-100 checkbox_with_input_design" : "checkbox_btn withoutchecked w-100 checkbox_with_input_design"} value="Others">
                                                        Others

                                                        <Input className='form_control basic' placeholder='Enter here' autoComplete="off"
                                                            disabled={(!inventoryMonetize.includes("Others") || isDisabled)}
                                                            value={inventoryMonetize.includes("Others") ? inventoryMonetizeOther : ""}
                                                            onChange={(e) => {
                                                                setInventoryMonetizeOther(e.target.value);
                                                                if (e.target.value.trim().length > 0) {
                                                                    setInventoryMonetizeOtherIsRequiredError(false);
                                                                }
                                                            }}
                                                        />

                                                    </Checkbox>
                                                    {inventoryMonetize.includes("Others") && inventoryMonetizeOtherIsRequiredError && (
                                                        <span className="error_content">Please provide value for others</span>
                                                    )}
                                                </Checkbox.Group>
                                                {inventoryMonetizeIsRequiredError && (
                                                    <span className="error_content">This field is required</span>
                                                )}
                                            </div>
                                        </div>
                                    </Col>
                                    {inventoryMonetize.includes("Website") &&
                                        <>
                                            <Col span={24}>
                                                <hr className='divider_line' />
                                            </Col>
                                            <Col span={24}>
                                                <div className="form_content_block--group">
                                                    <div className=''>
                                                        <label className="form_label">Do you support User Syncing on websites?</label>
                                                        <Radio.Group className="form_radio equal_space"
                                                            value={inventoryMonetizeWebsiteUserSync}
                                                            onChange={onChangeInventoryMonetizeWebsiteUserSync}
                                                            disabled={isDisabled}
                                                        >
                                                            <Radio className='radio_btn w-auto' value={true}>Yes</Radio>
                                                            <Radio className='radio_btn w-auto' value={false}>No</Radio>
                                                        </Radio.Group>
                                                        {inventoryMonetizeWebsiteUserSyncIsRequiredError && (
                                                            <span className="error_content">This field is required</span>
                                                        )}
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col span={24}>
                                                <div className="form_content_block--group mb-0">
                                                    <div className=''>
                                                        <label className="form_label">Do you allow Outstream video (IBV) over banner placements? (Website)</label>
                                                        <Radio.Group className="form_radio equal_space"
                                                            value={inventoryMonetizeWebsiteBanner}
                                                            onChange={onChangeInventoryMonetizeWebsiteBanner}
                                                            disabled={isDisabled}
                                                        >
                                                            <Radio className='radio_btn w-auto' value={true}>Yes</Radio>
                                                            <Radio className='radio_btn w-auto' value={false}>No</Radio>
                                                        </Radio.Group>
                                                        {inventoryMonetizeWebsiteBannerIsRequiredError && (
                                                            <span className="error_content">This field is required</span>
                                                        )}
                                                    </div>
                                                </div>
                                            </Col>
                                        </>
                                    }

                                </Row>
                            </div>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col span={8}>
                            <div className="container_box--label-info">
                                <label>What ad formats do you want to monetize? *</label>
                            </div>
                        </Col>

                        <Col span={16}>
                            <div className="container_box--form-container" ref={adFormatMonetizeRef}>
                                <Row gutter={16}>
                                    <Col span={24}>
                                        <div className="form_content_block--group mb-0">
                                            <div className=''>
                                                <Checkbox.Group className="form_checkbox equal_space"
                                                    value={adFormatMonetize}
                                                    onChange={onChangeAdFormatMonetize}
                                                >
                                                    <Checkbox className="checkbox_btn --flex_grow_cls integration_checkbox_width"
                                                        value="Instream Video">
                                                        Instream Video
                                                    </Checkbox>
                                                    <Checkbox className="checkbox_btn --flex_grow_cls integration_checkbox_width" value="Outstream / In-Article Video">
                                                        Outstream / In-Article Video
                                                    </Checkbox>
                                                    <Checkbox className="checkbox_btn --flex_grow_cls integration_checkbox_width" value="Rewarded Video">
                                                        Rewarded Video
                                                    </Checkbox>
                                                    <Checkbox className="checkbox_btn --flex_grow_cls integration_checkbox_width" value="Banner (Display)">
                                                        Banner (Display)
                                                    </Checkbox>
                                                    <Checkbox className="checkbox_btn --flex_grow_cls integration_checkbox_width" value="Native">
                                                        Native
                                                    </Checkbox>
                                                    <Checkbox className="checkbox_btn --flex_grow_cls integration_checkbox_width" value="Pause Ads">
                                                        Pause Ads
                                                    </Checkbox>
                                                    <Checkbox className={adFormatMonetize.includes("Others") ? "checkbox_btn w-100 checkbox_with_input_design" : "checkbox_btn withoutchecked w-100 checkbox_with_input_design"}
                                                        value="Others">
                                                        Others
                                                        <Input className='form_control basic' placeholder='Enter here' autoComplete="off"
                                                            disabled={(!adFormatMonetize.includes("Others") || isDisabled)}
                                                            value={adFormatMonetize.includes("Others") ? adFormatMonetizeOther : ""}
                                                            onChange={(e) => {
                                                                setAdFormatMonetizeOther(e.target.value);
                                                                if (e.target.value.trim().length > 0) setAdFormatMonetizeOtherIsRequiredError(false);
                                                            }}
                                                        />
                                                    </Checkbox>
                                                    {adFormatMonetize.includes("Others") && adFormatMonetizeOtherIsRequiredError && (
                                                        <span className="error_content">Please provide value for others</span>
                                                    )}
                                                </Checkbox.Group>
                                                {adFormatMonetizeIsRequiredError && (
                                                    <span className="error_content">This field is required</span>
                                                )}
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col span={8}>
                            <div className="container_box--label-info">
                                <label>Preferred Integration Method *</label>
                            </div>
                        </Col>

                        <Col span={16}>
                            <div className="container_box--form-container" ref={integrationTypeRef}>
                                <Row gutter={16}>
                                    <Col span={24}>
                                        <div className="form_content_block--group mb-0">
                                            <Checkbox.Group className="form_checkbox equal_space"
                                                value={integrationType} onChange={onChangeIntegrationType}
                                                disabled={isDisabled}
                                            >
                                                <Checkbox className="checkbox_btn w-100" value="Prebid">
                                                    Prebid
                                                </Checkbox>

                                                {integrationType.includes("Prebid") &&
                                                    <>

                                                        <Col span={24}>
                                                            <div className="form_content_block--group hide_caret_after_select_value mb-0 mt-3">
                                                                <label className="form_label">If you support header bidding, please specify the solution used. (e.g., Prebid.js, Amazon, PubMatic OpenWrap, etc) * </label>
                                                                <TextArea className={prebidQuestionIsRequiredError ? 'form_control error basic form_control_h --80 textarea_paddingY_d2' : 'form_control  basic form_control_h --80 textarea_paddingY_d2'} autoComplete="off"
                                                                    autoSize={{ minRows: 3, maxRows: 5, }}
                                                                    value={prebidQuestion}
                                                                    onChange={onChangePrebidQuestion}
                                                                    onBlur={onBlurPrebidQuestion}
                                                                    disabled={isDisabled}
                                                                />

                                                                <span className="error_content">
                                                                    {
                                                                        prebidQuestionIsRequiredError &&
                                                                        <>This field is requied</>
                                                                    }
                                                                </span>
                                                            </div>
                                                        </Col>
                                                        <Col span={24}>
                                                            <hr className="divider_line" />
                                                        </Col>
                                                    </>
                                                }
                                                <Checkbox className="checkbox_btn w-100" value="ORTB">
                                                    ORTB
                                                </Checkbox>
                                                {integrationType.includes("ORTB") &&
                                                    <>
                                                        <Col span={24}>
                                                            <div className="form_content_block--group mb-0 mt-3">
                                                                <label className="form_label">If your setup supports OpenRTB, please specify the version. (e.g., 2.3, 2.5, 2.6, etc) *</label>
                                                                <Input className={ortbQuestionIsRequiredError ? 'form_control basic error' : 'form_control  basic'} placeholder='Enter version' autoComplete="off"
                                                                    value={ortbQuestion}
                                                                    onChange={onChangeOrtbQuestion}
                                                                    onBlur={onBlurOrtbQuestion}
                                                                    disabled={isDisabled}
                                                                />

                                                                <span className="error_content">
                                                                    {
                                                                        ortbQuestionIsRequiredError &&
                                                                        <>This field is requied</>
                                                                    }
                                                                </span>
                                                            </div>
                                                        </Col>
                                                        <Col span={24}>
                                                            <div className="form_content_block--group mb-0">
                                                                <label className="form_label">Select the impression counting method you support. * </label>
                                                                <Checkbox.Group className="form_checkbox equal_space"
                                                                    value={ortbType} onChange={onChangeOrtbType}
                                                                    disabled={isDisabled}
                                                                >
                                                                    <Checkbox className="checkbox_btn --flex_grow_cls integration_checkbox_width" value="ADM">
                                                                        ADM
                                                                    </Checkbox>
                                                                    <Checkbox className="checkbox_btn --flex_grow_cls integration_checkbox_width" value="NURL">
                                                                        NURL
                                                                    </Checkbox>
                                                                    <Checkbox className="checkbox_btn --flex_grow_cls integration_checkbox_width" value="BURL">
                                                                        BURL
                                                                    </Checkbox>
                                                                </Checkbox.Group>
                                                                <span className='error_content'>
                                                                    {ortbTypeIsRequiredError && <> Minimum 1 selection is required</>}
                                                                </span>
                                                            </div>
                                                        </Col>
                                                        <Col span={24}>
                                                            <hr className="divider_line" />
                                                        </Col>
                                                    </>
                                                }
                                                <Checkbox className="checkbox_btn w-100" value="VAST">
                                                    VAST
                                                </Checkbox>

                                                {integrationType.includes("VAST") &&
                                                    <>

                                                        <Col span={24}>
                                                            <div className="form_content_block--group mb-0 mt-3">
                                                                <label className="form_label">Select the supported VAST Version * </label>
                                                                <Checkbox.Group className="form_checkbox equal_space"
                                                                    value={vastType} onChange={onChangeVastType}
                                                                    disabled={isDisabled}
                                                                >
                                                                    <Checkbox className="checkbox_btn --flex_grow_cls integration_checkbox_width" value="VAST VERSION 2.0">
                                                                        VAST VERSION 2.0
                                                                    </Checkbox>
                                                                    <Checkbox className="checkbox_btn --flex_grow_cls integration_checkbox_width" value="VAST VERSION 3.0">
                                                                        VAST VERSION 3.0
                                                                    </Checkbox>
                                                                    <Checkbox className="checkbox_btn --flex_grow_cls integration_checkbox_width" value="VAST VERSION 4.0">
                                                                        VAST VERSION 4.0
                                                                    </Checkbox>
                                                                </Checkbox.Group>
                                                            </div>
                                                            <span className="error_content">
                                                                {vastTypeIsRequiredError && <> Minimum 1 selection is required</>}
                                                            </span>
                                                        </Col>
                                                    </>
                                                }
                                            </Checkbox.Group>

                                            <span className='error_content'>
                                                {integrationTypeIsRequiredError &&
                                                    <>This field is required</>
                                                }
                                            </span>

                                        </div>
                                    </Col>





                                </Row>
                            </div>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col span={8}>
                            <div className="container_box--label-info">
                                <label>Integration & Protocol Support</label>
                            </div>
                        </Col>

                        <Col span={16}>
                            <div className="container_box--form-container" ref={integrationProtocolDetailsRef}>
                                <Row gutter={16}>
                                    <Col span={24}>
                                        <div className="form_content_block--group">
                                            <label className="form_label">Which Player/SDK Used for Video Inventory?</label>
                                            <Input className='form_control basic' placeholder='' autoComplete="off"
                                                value={integrationProtocolPlayer}
                                                onBlur={onBlurIntegrationProtocolPlayer}
                                                onChange={onChangeIntegrationProtocolPlayer}
                                                disabled={isDisabled}
                                            />
                                        </div>
                                    </Col>
                                    <Col span={24}>
                                        <div className="form_content_block--group">
                                            <label className="form_label">List the MIME types your ad placements support. (e.g., video/mp4, application/javascript, text/html) *</label>
                                            <Input
                                                className={
                                                    integrationProtocolMimeIsRequiredError
                                                        ? "form_control basic error"
                                                        : "form_control basic"
                                                }
                                                value={integrationProtocolMime}
                                                onBlur={onBlurIntegrationProtocolMime}
                                                onChange={onChangeIntegrationProtocolMime}
                                                autocomplete="off"
                                                disabled={isDisabled}
                                            />
                                            <span className='error_content'>
                                                {integrationProtocolMimeIsRequiredError && (
                                                    <> This field is required</>
                                                )}
                                            </span>
                                        </div>
                                    </Col>
                                    <Col span={24}>
                                        <div className="form_content_block--group">
                                            <label className="form_label">Please specify your maximum timeout (Tmax) in milliseconds. (This is the time you allow for a bid response)</label>
                                            <Input className='form_control basic' placeholder='' autoComplete="off"
                                                value={integrationProtocolTimeout}
                                                onBlur={onBlurIntegrationProtocolTimeout}
                                                onChange={onChangeIntegrationProtocolTimeout}
                                                disabled={isDisabled}
                                            />
                                        </div>
                                    </Col>
                                    <Col span={24}>
                                        <div className="form_content_block--group">
                                            <label className="form_label">Please specify where your ad servers are hosted. (e.g., AWS US-East, GCP Europe,etc)</label>
                                            <Input className='form_control basic' placeholder='' autoComplete="off"
                                                value={integrationProtocolAdserver}
                                                onBlur={onBlurIntegrationProtocolAdserver}
                                                onChange={onChangeIntegrationProtocolAdserver}
                                                disabled={isDisabled}
                                            />
                                        </div>
                                    </Col>
                                    <Col span={24}>
                                        <div className="form_content_block--group">
                                            <div className=''>
                                                <label className="form_label">Do you support multiple impressions in a single request</label>
                                                <Radio.Group className="form_radio equal_space"
                                                    disabled={isDisabled}
                                                    onChange={onChangeIntegrationProtocolImpression}
                                                    value={integrationProtocolImpression}
                                                >
                                                    <Radio className='radio_btn w-auto' value={true} onChange={onChangeIntegrationProtocolImpression}>Yes</Radio>
                                                    <Radio className='radio_btn w-auto' value={false} onChange={onChangeIntegrationProtocolImpression}>No</Radio>
                                                </Radio.Group>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col span={24}>
                                        <div className="form_content_block--group">
                                            <label className="form_label">Do your bid requests include content-level parameters such as channel, genre, language, or content rating?</label>
                                            <Input className='form_control basic' placeholder='' autoComplete="off"
                                                value={integrationProtocolBidrequest}
                                                onBlur={onBlurIntegrationProtocolBidrequest}
                                                onChange={onChangeIntegrationProtocolBidrequest}
                                                disabled={isDisabled}
                                            />
                                        </div>
                                    </Col>
                                    <Col span={24}>
                                        <div className="form_content_block--group">
                                            <div className=''>
                                                <label className="form_label">Can you pass buyer uid and uid in requests?</label>
                                                <Radio.Group className="form_radio equal_space"
                                                    disabled={isDisabled}
                                                    onChange={onChangeIntegrationProtocolUid}
                                                    value={integrationProtocolUid}
                                                >
                                                    <Radio className='radio_btn w-auto' value={true} onChange={onChangeIntegrationProtocolUid}>Yes</Radio>
                                                    <Radio className='radio_btn w-auto' value={false} onChange={onChangeIntegrationProtocolUid}>No</Radio>
                                                </Radio.Group>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col span={24}>
                                        <div className={integrationProtocolRichMedia ? "form_content_block--group" : "form_content_block--group mb-0"}>
                                            <div className=''>
                                                <label className="form_label">Do you support Rich Media creatives? *</label>
                                                <Radio.Group className="form_radio equal_space"
                                                    onChange={onChangeIntegrationProtocolRichMedia} value={integrationProtocolRichMedia}
                                                    disabled={isDisabled}
                                                >
                                                    <Radio className='radio_btn w-auto' value={true} onChange={onChangeIntegrationProtocolRichMedia}>Yes</Radio>
                                                    <Radio className='radio_btn w-auto' value={false} onChange={onChangeIntegrationProtocolRichMedia}>No</Radio>
                                                </Radio.Group>
                                                <span className="error_content">
                                                    {integrationProtocolRichMediaIsRequiredError && (
                                                        <> This field is required</>
                                                    )}
                                                </span>
                                            </div>
                                        </div>
                                    </Col>
                                    {integrationProtocolRichMedia &&
                                        <Col span={24}>
                                            <div className="form_content_block--group mb-0">
                                                <label className="form_label">Select supported Rich Media creatives</label>
                                                <Checkbox.Group className="form_checkbox equal_space"
                                                    value={integrationProtocolRichMediaCreative}
                                                    onChange={onChangeIntegrationProtocolRichMediaCreative}
                                                    disabled={isDisabled}

                                                >
                                                    <Checkbox className="checkbox_btn --flex_grow_cls integration_checkbox_width" value="MRAID">
                                                        MRAID
                                                    </Checkbox>
                                                    <Checkbox className="checkbox_btn --flex_grow_cls integration_checkbox_width" value="HTML">
                                                        HTML
                                                    </Checkbox>
                                                    <Checkbox className="checkbox_btn --flex_grow_cls integration_checkbox_width" value="Expandable">
                                                        Expandable
                                                    </Checkbox>
                                                    <Checkbox className="checkbox_btn --flex_grow_cls integration_checkbox_width" value="JS">
                                                        JS
                                                    </Checkbox>
                                                </Checkbox.Group>
                                            </div>
                                        </Col>
                                    }
                                </Row>
                            </div>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col span={8}>
                            <div className="container_box--label-info">
                                <label>Regulation & Brand Safety</label>
                            </div>
                        </Col>

                        <Col span={16}>
                            <div className="container_box--form-container" ref={regulationDetailsRef}>
                                <Row gutter={16}>
                                    <Col span={24}>
                                        <div className="form_content_block--group">
                                            <label className="form_label">Which anti-fraud tools do you use? (Pixalate, MOAT, etc.) *</label>
                                            <Input
                                                className={
                                                    regulationToolIsRequiredError
                                                        ? "form_control basic error"
                                                        : "form_control basic"
                                                }
                                                value={regulationTool}
                                                onBlur={onBlurRegulationTool}
                                                onChange={onChangeRegulationTool}
                                                disabled={isDisabled}
                                                autoComplete="off" />
                                            <span className='error_content'>
                                                {regulationToolIsRequiredError && (
                                                    <> This field is required</>
                                                )}
                                            </span>
                                        </div>
                                    </Col>
                                    <Col span={24}>
                                        <div className="form_content_block--group">
                                            <label className="form_label">Which adserver do you use? (GAM, SpringServe, Publica, etc.) *</label>
                                            <Input
                                                className={
                                                    regulationAdserverIsRequiredError
                                                        ? "form_control basic error"
                                                        : "form_control basic"
                                                }
                                                value={regulationAdserver}
                                                onBlur={onBlurRegulationAdserver}
                                                onChange={onChangeRegulationAdserver}
                                                disabled={isDisabled}
                                                autoComplete="off" />
                                            <span className='error_content'>
                                                {regulationAdserverIsRequiredError && (
                                                    <> This field is required</>
                                                )}
                                            </span>
                                        </div>
                                    </Col>
                                    <Col span={24}>
                                        <div className="form_content_block--group mb-0">
                                            <label className="form_label">Which regulatory parameters you support ? *</label>
                                            <Checkbox.Group className="form_checkbox equal_space"
                                                value={regulationParameter} onChange={onChangeRegulationParameter}
                                                disabled={isDisabled}
                                            >
                                                <Checkbox className="checkbox_btn --flex_grow_cls integration_checkbox_width" value="GDPR">
                                                    GDPR
                                                </Checkbox>
                                                <Checkbox className="checkbox_btn --flex_grow_cls integration_checkbox_width" value="COPPA">
                                                    COPPA
                                                </Checkbox>
                                                <Checkbox className="checkbox_btn --flex_grow_cls integration_checkbox_width" value="US Privacy">
                                                    US Privacy
                                                </Checkbox>
                                                <Checkbox className="checkbox_btn --flex_grow_cls integration_checkbox_width" value="TCF">
                                                    TCF
                                                </Checkbox>
                                                <Checkbox className={regulationParameter.includes("Others") ? "checkbox_btn w-100 checkbox_with_input_design" : "checkbox_btn withoutchecked w-100 checkbox_with_input_design"}
                                                    value="Others">
                                                    Others
                                                    <Input className='form_control basic' placeholder='Enter here' autoComplete="off"
                                                        disabled={(!regulationParameter.includes("Others") || isDisabled)}
                                                        value={regulationParameter.includes("Others") ? regulationParameterOther : ""}
                                                        onChange={(e) => {
                                                            setRegulationParameterOther(e.target.value);
                                                            if (e.target.value.trim().length > 0) setRegulationParameterOtherIsRequiredError(false);
                                                        }}
                                                    />
                                                </Checkbox>
                                                {regulationParameter.includes("Others") && regulationParameterOtherIsRequiredError && (
                                                    <span className="error_content">Please provide value for others</span>
                                                )}
                                            </Checkbox.Group>
                                            {regulationParameterIsRequiredError && (
                                                <span className="error_content">This field is required</span>
                                            )}
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col span={8}>
                            <div className="container_box--label-info">
                                <label>Sensitive categories you would like us to block on your supply.</label>
                            </div>
                        </Col>

                        <Col span={16}>
                            <div className="container_box--form-container " ref={sensitiveDetailsRef}>
                                <Row gutter={16}>
                                    <Col span={24}>
                                        <div className="form_content_block--group mb-0">
                                            <div className="block-category block_category_adjustment --table_width_css">
                                                <div className="form_content_block--group mb-0">
                                                    <div className="d_flex justify_content_between mb_10 align-items-center">
                                                        <Input
                                                            type='text'
                                                            className='form_control basic md search_input w_table_search'
                                                            placeholder="Search"
                                                            value={search}
                                                            onChange={e => setSearch(e.target.value)}
                                                        />
                                                        {/* <span className='row_count_value_d2'>{getSelectedChildrenCount(DATA, selected)} Selected</span> */}
                                                        <div className='primary_checkbox mb_10'>
                                                            <Checkbox
                                                                checked={blockAllChecked}
                                                                onChange={handleBlockAll}
                                                                disabled={isDisabled}
                                                            >
                                                                <span className="form_label">Block all sensitive categories</span>
                                                            </Checkbox>
                                                        </div>
                                                    </div>
                                                    {/* <div className='primary_checkbox mb_10'>
                                                        <Checkbox
                                                            checked={blockAllChecked}
                                                            onChange={handleBlockAll}
                                                            disabled={isDisabled}
                                                        >
                                                            <span className="form_label">Block all sensitive categories</span>
                                                        </Checkbox>
                                                    </div> */}
                                                </div>
                                                <div className="table-body-scroll without_hover_tr">
                                                    <table className="category-table --category_table_newspacing">
                                                        {/* <thead>
                                                <tr>
                                                    <th className="cell checkbox-col" style={{ borderRight: "1px solid #EAECF0" }}>
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            ref={masterRef}
                                                            checked={allSelectedAll}
                                                            onChange={handleMaster}
                                                            aria-label="Select all"
                                                            disabled={isDisabled}
                                                        />
                                                    </th>
                                                    <th className="name-col">Name</th>
                                                </tr>
                                            </thead> */}
                                                        <tbody className="scroll-body">
                                                            {DATA.length > 0 ? (

                                                                // DATA.map((node, index) => (
                                                                //   <CategoryRows
                                                                //     key={node.id}
                                                                //     node={node}
                                                                //     selected={selected}
                                                                //     setSelected={setSelected}
                                                                //     searchTerm={searchTerm}
                                                                //     defaultOpen={index === 0}
                                                                //   />
                                                                // ))

                                                                visibleNodes.length === 0 ? (
                                                                    <tr>
                                                                        <td colSpan={2} style={{ textAlign: "center", height: "20rem", width: "72rem" }}>
                                                                            <div className="no-data">No data found</div>
                                                                        </td>
                                                                    </tr>
                                                                ) : (
                                                                    visibleNodes.map(node => (
                                                                        <CategoryRows
                                                                            key={node.id}
                                                                            node={node}
                                                                            selected={selected}
                                                                            setSelected={setSelected}
                                                                            searchTerm={searchTerm.toLowerCase()}
                                                                            // checkRole={checkRole}
                                                                            isDisabled={isDisabled}
                                                                            sensitive={sensitive}
                                                                            setSensitive={setSensitive}
                                                                            attemptedIds={sensitiveAttemptedIds}
                                                                            setSensitiveAttemptedIds={setSensitiveAttemptedIds}
                                                                        />
                                                                    ))
                                                                )



                                                            ) : (
                                                                <tr>
                                                                    <td colSpan={2} style={{ textAlign: "center", height: "20rem", width: "72rem" }}>
                                                                        <div className="no-data">No data found</div>
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>

                    {props.callFrom === "listing" && <Row gutter={16}>
                        <Col span={8}>
                            <div className="container_box--label-info">
                                <label>RTB Seller</label>
                            </div>
                        </Col>

                        <Col span={16}>
                            <div className="container_box--form-container" ref={sellerDetailsRef}>
                                <Row gutter={16}>
                                    <Col span={24}>
                                        <div className="form_content_block--group">
                                            <label className="form_label">Seller Type  *</label>
                                            <Radio.Group className="form_radio two_radio_box_design_d2 w-100"
                                                onChange={onChangeSellerType} value={sellerType}
                                                disabled={isDisabled}
                                            >
                                                <Row gutter={16}>
                                                    <Col span={8}>
                                                        <Radio className="radio_btn w-100" value="Publisher">
                                                            Publisher
                                                        </Radio>
                                                    </Col>
                                                    <Col span={8}>
                                                        <Radio className="radio_btn w-100" value="Intermediary">
                                                            Intermediary
                                                        </Radio>
                                                    </Col>
                                                    <Col span={8}>
                                                        <Radio className="radio_btn w-100" value="Both">
                                                            Both
                                                        </Radio>
                                                    </Col>
                                                </Row>
                                            </Radio.Group>
                                            <span className="error_content">
                                                {sellerTypeIsRequiredError && (
                                                    <> This field is required</>
                                                )}
                                            </span>

                                        </div>
                                    </Col>
                                    <Col span={12}>
                                        <div className="form_content_block--group">
                                            <label className="form_label">Seller Name *</label>
                                            <Input
                                                className={sellerNameIsRequiredError
                                                    ? "form_control basic error"
                                                    : "form_control basic"
                                                }
                                                value={sellerName}
                                                onBlur={onBlurSellerName}
                                                onChange={onChangeSellerName}
                                                disabled={isDisabled}
                                                autoComplete="off" />
                                            <span className="error_content">
                                                {sellerNameIsRequiredError && (
                                                    <> This field is required</>
                                                )}
                                            </span>

                                        </div>
                                    </Col>
                                    <Col span={12}>
                                        <div className="form_content_block--group">
                                            <label className="form_label">Seller Domain *</label>
                                            <Input
                                                className={(sellerDomainIsRequiredError || sellerDomainUrlError)
                                                    ? "form_control basic error"
                                                    : "form_control basic"
                                                }
                                                value={sellerDomain}
                                                onBlur={onBlurSellerDomain}
                                                onChange={onChangeSellerDomain}
                                                disabled={isDisabled}
                                                autoComplete="off" />
                                            <span className="error_content">
                                                {sellerDomainIsRequiredError && (
                                                    <> This field is required</>
                                                )}

                                                {sellerDomainUrlError && (
                                                    <> Invalid Domain</>
                                                )}
                                            </span>
                                        </div>
                                    </Col>
                                    <Col span={24}>
                                        <div className="form_content_block--group mb-0">
                                            <div className="primary_checkbox">
                                                <Checkbox
                                                    id="running_ibv_checkbox"
                                                    name="running_ibv_checkbox"
                                                    checked={isSellerPassThroughCheckbox}
                                                    onChange={onChangeIsSellerPassThroughCheckbox}
                                                    disabled={isDisabled}

                                                >
                                                    <span className="form_label">
                                                        Seller Passthrough
                                                    </span>
                                                </Checkbox>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>}

                    {/* Upload inventory list section - commented out */}
                    {false && props.callFrom !== "profile" &&
                        <>
                            {(props.callFrom === "listing" ? (currentStatus === "onboard" || currentStatus === "new") ? true : false : true) &&
                                <>
                                    {(inventoryMonetize.includes("CTV / FAST Apps") || inventoryMonetize.includes("Mobile App (Android / iOS)") || inventoryMonetize.includes("Website")) &&
                                        <Row gutter={16}>
                                            <Col span={8}>
                                                <div className="container_box--label-info">
                                                    <label>Upload your inventory list</label>
                                                </div>
                                            </Col>

                                            <Col span={16}>
                                                <div className="container_box--form-container">
                                                    <Row gutter={16}>
                                                        <Col span={24}>
                                                            <div className="form_content_block--group --upload_delete_view mb-0">
                                                                <label className="form_label">Upload Inventory Files  </label>
                                                                <div className="ant_upload_list--item">
                                                                    {
                                                                        inventoryMonetize.includes("CTV / FAST Apps") &&
                                                                        <>

                                                                            <div className='d-flex align-items-center justify-content-between'>
                                                                                <div className="ant_upload_list--content">
                                                                                    <div className="ant_upload_list--info">
                                                                                        <span className="ant_upload_list--info-name">
                                                                                            CTV / FAST Apps
                                                                                            {inventoryCtvName !== "" && <img src={GreenCheckBg} alt="USP" className='ms-2' />}
                                                                                        </span>
                                                                                    </div>
                                                                                </div>
                                                                                {inventoryCtvName !== "" ?
                                                                                    <div className="d-flex justify_content_end">
                                                                                        <span className='file_format_name' onClick={() => { handleShow("CTV / FAST Apps") }}>{inventoryCtvName}</span>

                                                                                        <button type="link" className="ant_upload_list--delete">
                                                                                            <Tooltip title="Edit">
                                                                                                <img src={Edit} alt="USP" onClick={() => { handleShow("CTV / FAST Apps") }} />
                                                                                            </Tooltip>
                                                                                        </button>
                                                                                        {!isDisabled &&
                                                                                            <button type="link" className="ant_upload_list--delete"
                                                                                                onClick={() => {
                                                                                                    setInventoryCtvData([])
                                                                                                    setInventoryCtvName("")
                                                                                                }}

                                                                                            >
                                                                                                <Tooltip title="Delete">
                                                                                                    <img src={deleteIcon} alt="USP" />
                                                                                                </Tooltip>
                                                                                            </button>
                                                                                        }

                                                                                    </div>
                                                                                    :
                                                                                    <div className="d-flex justify_content_end align-items-center download_button_with_text">
                                                                                        <div className="cursor_pointer_cls"
                                                                                            onClick={() => { handleDownload("ctv") }}
                                                                                        >
                                                                                            <img src={DownloadOrangeIcon} alt="USP" />
                                                                                            <span className='file_format_name'>Download Sample Format</span>

                                                                                        </div>


                                                                                        <button type="button" className="upload_btn">
                                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                                                                <path d="M10.3637 10.3645L7.99924 8L5.63477 10.3645" stroke="#7434DB" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                                                <path d="M8 8V13.3201" stroke="#7434DB" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                                                <path d="M12.9591 11.7773C13.5356 11.4629 13.9911 10.9656 14.2536 10.3637C14.516 9.76176 14.5706 9.08958 14.4086 8.45321C14.2467 7.81685 13.8774 7.25255 13.3591 6.84937C12.8408 6.44618 12.203 6.22709 11.5463 6.22665H10.8015C10.6226 5.5346 10.2891 4.89211 9.82612 4.34748C9.36315 3.80286 8.78274 3.37028 8.12852 3.08226C7.4743 2.79425 6.7633 2.65828 6.04897 2.6846C5.33465 2.71092 4.63558 2.89884 4.00433 3.23422C3.37308 3.5696 2.82607 4.04371 2.40444 4.62093C1.9828 5.19814 1.6975 5.86343 1.56999 6.56678C1.44248 7.27013 1.47607 7.99323 1.66825 8.68172C1.86043 9.37022 2.20619 10.0062 2.67953 10.5418" stroke="#7434DB" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                                                <path d="M10.3637 10.3645L7.99924 8L5.63477 10.3645" stroke="#7434DB" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                                            </svg>
                                                                                            <input
                                                                                                type="file"
                                                                                                accept=".xlsx,.xls,.csv"
                                                                                                onChange={(e) => {
                                                                                                    const file = e.target.files && e.target.files[0];
                                                                                                    if (!file) return;
                                                                                                    handleBeforeUpload(file, "CTV / FAST Apps");
                                                                                                    // optional: allow re-uploading same file
                                                                                                    e.target.value = "";
                                                                                                }}
                                                                                                disabled={isDisabled}
                                                                                            />
                                                                                            Upload
                                                                                        </button>
                                                                                    </div>

                                                                                }

                                                                            </div>
                                                                        </>
                                                                    }
                                                                    {
                                                                        inventoryMonetize.includes("Mobile App (Android / iOS)") &&
                                                                        <>
                                                                            {inventoryMonetize.includes("CTV / FAST Apps") &&
                                                                                <hr className='divide_line' />
                                                                            }
                                                                            <div className='d-flex align-items-center justify-content-between'>
                                                                                <div className="ant_upload_list--content">
                                                                                    <div className="ant_upload_list--info">
                                                                                        <span className="ant_upload_list--info-name">
                                                                                            Mobile App (Android / iOS)
                                                                                            {inventoryMobileName !== "" && <img src={GreenCheckBg} alt="USP" className='ms-2' />}
                                                                                        </span>
                                                                                    </div>
                                                                                </div>
                                                                                {inventoryMobileName !== "" ?
                                                                                    <div className="d-flex justify_content_end">
                                                                                        <span className='file_format_name' onClick={() => { handleShow("Mobile App (Android / iOS)") }}>{inventoryMobileName}</span>


                                                                                        <button type="link" className="ant_upload_list--delete">
                                                                                            <Tooltip title="Edit">
                                                                                                <img src={Edit} alt="USP" onClick={() => { handleShow("Mobile App (Android / iOS)") }} />
                                                                                            </Tooltip>
                                                                                        </button>
                                                                                        {!isDisabled &&
                                                                                            <button type="link" className="ant_upload_list--delete"
                                                                                                onClick={() => {
                                                                                                    setInventoryMobileData([])
                                                                                                    setInventoryMobileName("")
                                                                                                }}
                                                                                            >
                                                                                                <Tooltip title="Delete">
                                                                                                    <img src={deleteIcon} alt="USP" />
                                                                                                </Tooltip>
                                                                                            </button>

                                                                                        }

                                                                                    </div>
                                                                                    :
                                                                                    <div className="d-flex justify_content_end align-items-center download_button_with_text">
                                                                                        <div className="cursor_pointer_cls"
                                                                                            onClick={() => { handleDownload("inapp") }}
                                                                                        >
                                                                                            <img src={DownloadOrangeIcon} alt="USP" />
                                                                                            <span className='file_format_name'>Download Sample Format</span>

                                                                                        </div>


                                                                                        <button type="button" className="upload_btn">
                                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                                                                <path d="M10.3637 10.3645L7.99924 8L5.63477 10.3645" stroke="#7434DB" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                                                <path d="M8 8V13.3201" stroke="#7434DB" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                                                <path d="M12.9591 11.7773C13.5356 11.4629 13.9911 10.9656 14.2536 10.3637C14.516 9.76176 14.5706 9.08958 14.4086 8.45321C14.2467 7.81685 13.8774 7.25255 13.3591 6.84937C12.8408 6.44618 12.203 6.22709 11.5463 6.22665H10.8015C10.6226 5.5346 10.2891 4.89211 9.82612 4.34748C9.36315 3.80286 8.78274 3.37028 8.12852 3.08226C7.4743 2.79425 6.7633 2.65828 6.04897 2.6846C5.33465 2.71092 4.63558 2.89884 4.00433 3.23422C3.37308 3.5696 2.82607 4.04371 2.40444 4.62093C1.9828 5.19814 1.6975 5.86343 1.56999 6.56678C1.44248 7.27013 1.47607 7.99323 1.66825 8.68172C1.86043 9.37022 2.20619 10.0062 2.67953 10.5418" stroke="#7434DB" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                                                <path d="M10.3637 10.3645L7.99924 8L5.63477 10.3645" stroke="#7434DB" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                                            </svg>
                                                                                            <input
                                                                                                type="file"
                                                                                                accept=".xlsx,.xls,.csv"
                                                                                                onChange={(e) => {
                                                                                                    const file = e.target.files && e.target.files[0];
                                                                                                    if (!file) return;
                                                                                                    handleBeforeUpload(file, "Mobile App (Android / iOS)");
                                                                                                    // optional: allow re-uploading same file
                                                                                                    e.target.value = "";
                                                                                                }}
                                                                                                disabled={isDisabled}
                                                                                            />
                                                                                            Upload
                                                                                        </button>
                                                                                    </div>

                                                                                }

                                                                            </div>
                                                                        </>
                                                                    }
                                                                    {inventoryMonetize.includes("Website") &&
                                                                        <>
                                                                            {(inventoryMonetize.includes("Mobile App (Android / iOS)") || inventoryMonetize.includes("CTV / FAST Apps")) &&
                                                                                <hr className='divide_line' />
                                                                            }
                                                                            <div className='d-flex align-items-center justify-content-between'>
                                                                                <div className="ant_upload_list--content">
                                                                                    <div className="ant_upload_list--info">
                                                                                        <span className="ant_upload_list--info-name">
                                                                                            Website
                                                                                            {inventoryWebsiteName !== "" && <img src={GreenCheckBg} alt="USP" className='ms-2' />}
                                                                                        </span>
                                                                                    </div>
                                                                                </div>
                                                                                {inventoryWebsiteName !== "" ?
                                                                                    <div className="d-flex justify_content_end">
                                                                                        <span className='file_format_name' onClick={() => { handleShow("Website") }}>{inventoryWebsiteName}</span>

                                                                                        <button type="link" className="ant_upload_list--delete">
                                                                                            <Tooltip title="Edit">
                                                                                                <img src={Edit} alt="USP" onClick={() => { handleShow("Website") }} />
                                                                                            </Tooltip>
                                                                                        </button>
                                                                                        {!isDisabled &&
                                                                                            <button type="link" className="ant_upload_list--delete"
                                                                                                onClick={() => {
                                                                                                    setInventoryWebsiteData([])
                                                                                                    setInventoryWebsiteName("")
                                                                                                }}
                                                                                            >
                                                                                                <Tooltip title="Delete">
                                                                                                    <img src={deleteIcon} alt="USP" />
                                                                                                </Tooltip>
                                                                                            </button>
                                                                                        }

                                                                                    </div>
                                                                                    :
                                                                                    <div className="d-flex justify_content_end align-items-center download_button_with_text">
                                                                                        <div className="cursor_pointer_cls"
                                                                                            onClick={() => { handleDownload("website") }}
                                                                                        >
                                                                                            <img src={DownloadOrangeIcon} alt="USP" />
                                                                                            <span className='file_format_name'>Download Sample Format</span>

                                                                                        </div>


                                                                                        <button type="button" className="upload_btn">
                                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                                                                <path d="M10.3637 10.3645L7.99924 8L5.63477 10.3645" stroke="#7434DB" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                                                <path d="M8 8V13.3201" stroke="#7434DB" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                                                <path d="M12.9591 11.7773C13.5356 11.4629 13.9911 10.9656 14.2536 10.3637C14.516 9.76176 14.5706 9.08958 14.4086 8.45321C14.2467 7.81685 13.8774 7.25255 13.3591 6.84937C12.8408 6.44618 12.203 6.22709 11.5463 6.22665H10.8015C10.6226 5.5346 10.2891 4.89211 9.82612 4.34748C9.36315 3.80286 8.78274 3.37028 8.12852 3.08226C7.4743 2.79425 6.7633 2.65828 6.04897 2.6846C5.33465 2.71092 4.63558 2.89884 4.00433 3.23422C3.37308 3.5696 2.82607 4.04371 2.40444 4.62093C1.9828 5.19814 1.6975 5.86343 1.56999 6.56678C1.44248 7.27013 1.47607 7.99323 1.66825 8.68172C1.86043 9.37022 2.20619 10.0062 2.67953 10.5418" stroke="#7434DB" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                                                <path d="M10.3637 10.3645L7.99924 8L5.63477 10.3645" stroke="#7434DB" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                                                            </svg>
                                                                                            <input
                                                                                                type="file"
                                                                                                accept=".xlsx,.xls,.csv"
                                                                                                onChange={(e) => {
                                                                                                    const file = e.target.files && e.target.files[0];
                                                                                                    if (!file) return;
                                                                                                    handleBeforeUpload(file, "Website");
                                                                                                    // optional: allow re-uploading same file
                                                                                                    e.target.value = "";
                                                                                                }}
                                                                                                disabled={isDisabled}
                                                                                            />
                                                                                            Upload
                                                                                        </button>
                                                                                    </div>

                                                                                }

                                                                            </div>
                                                                        </>
                                                                    }
                                                                </div>
                                                            </div>
                                                        </Col>
                                                        <Offcanvas show={show} onHide={handleClose} placement='end' className="offcanva_design_cls">
                                                            <Offcanvas.Header closeButton>
                                                                <Offcanvas.Title>
                                                                    {/* <img src={FileIcon} className='img-fluid' alt="" /> */}
                                                                    {inventoryType}
                                                                </Offcanvas.Title>
                                                            </Offcanvas.Header>
                                                            <Offcanvas.Body>
                                                                <div className="form_content_block--group w-50 d_flex mb-3">
                                                                    {/* <Input type='text' className='form_control basic md search_input w_table_search' placeholder="Search" /> */}
                                                                </div>
                                                                <div className="table_content--box no_data_screen_view user_sync_table_v2 ">
                                                                    <div className='table_ant_select_cls'>

                                                                        <Form form={form} component={false}>
                                                                            <Table
                                                                                components={{ body: { cell: EditableCell } }}
                                                                                dataSource={inventoryType === "Website" ? inventoryWebsiteData : inventoryType === "CTV / FAST Apps" ? inventoryCtvData : inventoryType === "Mobile App (Android / iOS)" ? inventoryMobileData : []}
                                                                                columns={columnsWithActions}
                                                                                rowClassName="editable-row"
                                                                                pagination={false}
                                                                                scroll={{ x: "max-content" }}
                                                                            />
                                                                        </Form>
                                                                    </div>
                                                                </div>
                                                            </Offcanvas.Body>
                                                        </Offcanvas>
                                                    </Row>
                                                </div>
                                            </Col>
                                        </Row>
                                    }
                                </>
                            }
                        </>
                    }
                </div>

                <>
                    <div style={{ marginBottom: "8rem" }}></div>

                    {!isDisabled &&
                        <>
                            <div className="hr_custom mb_20"></div>

                            <div className="btn_group justify-content-end gap_8 pb_50 edit_view_fixedbtn_d2">
                                {buttonValue ? (
                                    <button className='btn_primary btn loader w_120_d2 btn btn_primary w_fit_content'
                                        style={{ cursor: "default" }}
                                    >
                                        <span>Save</span>
                                        <img src={loaderIcon} alt='USP' className='loader_icon' />
                                    </button>
                                ) : (
                                    <button className='w_120_d2 btn btn_primary w_fit_content'
                                        onClick={handleSubmit}
                                    >
                                        <span>Save</span>
                                        <img src={loaderIcon} alt='USP' className='loader_icon' />
                                    </button>
                                )}
                            </div>
                        </>
                    }
                </>
            </div>
        </div >


    )
}

export default MyProfileV2
